import {
  Component,
  ContentChild,
  ElementRef,
  EventEmitter, Inject, Input, OnInit,
  Output,
  Renderer2, TemplateRef, ViewChild
} from "@angular/core";
import {
  NgbDropdown,
  NgbModal,
  NgbModalConfig, NgbOffcanvas
} from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
// import moment from 'moment';
import { DOCUMENT } from "@angular/common";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import * as _ from "lodash";
import { CookieService } from "ngx-cookie-service";
import { forkJoin } from "rxjs";
import { breadcrumbItem } from "src/app/components/breadcrumbs/breadcrumbs.model";
import { TranslatePipe } from "src/app/core/pipes/translate.pipe";
import { AlertService } from "src/app/core/services/AlertService/alert.service";
import { AppAliasService } from "src/app/core/services/app-alias.service";
import { locationBroadcastService } from "src/app/core/services/loaction-broadcast.service";
import { PermissionService } from "src/app/core/services/permission.service";
import { SalesTransactionService } from "src/app/core/services/sales/transactions/salestransaction.service.service";
import { ApiService } from "src/app/services/api";
import { BreadcrumbService } from "src/app/services/breadcrumb";
import { TimezoneService } from "src/app/services/timezone";
import { TransactionSummarySharedComponent } from "src/app/shared/ui/modal-transactions/transaction-summary-shared/transaction-summary-shared.component";
import { AppState } from "src/app/store/app.state";
import { setLoadingSpinner } from "src/app/store/sharedstate/shared.actions";
import {
  salesTransactionEmployeeFetchStart,
  salesTransactionFetchStart,
  salesTransactionsSummaryFetchStart,
} from "../../../../app/pages/sales/transactions/state/transaction.actions";
import {
  getActiveEmployees,
  getSalesTransactionEmployeeData,
  getSalesTransactionMetaData,
  getSalesTransactions,
  getSalesTransactionSummaryData,
} from "../../../../app/pages/sales/transactions/state/transaction.selector";
import { TransactionOrderEditComponent } from "../../../../app/pages/sales/transactions/components/transaction-order-edit/transaction-order-edit.component";
@Component({
    selector: 'app-admin-transactions-details',
    templateUrl: './admin-transactions-details.component.html',
    styleUrls: ['./admin-transactions-details.component.scss'],
    // providers: [TranslatePipe],
})
export class AdminTransactionsDetailsComponent implements OnInit {
  @Input() isSuperAdmin: boolean = false;
  @Input() isMerchantId: string = "";
  breadcrumbItems: breadcrumbItem[] = [
    {
      label: "Home",
      active: false,
      url: "/home",
    },
    {
      label: "Sales",
      active: false,
      url: "/sales/transactions/sales-home",
      // url:'/sales/transactions'
    },
    {
      label: "Transactions",
      active: true,
      url: "",
    },
  ];

  public sd: string;
  public ed: string;
  isOpen: boolean = false;
  @ViewChild("myDrop", { static: true }) myDrop: NgbDropdown;
  @Output() changed: EventEmitter<any> = new EventEmitter();
  // @ContentChild(TransactionOrderEditComponent)
  @ViewChild(TransactionOrderEditComponent)
  childRef: TransactionOrderEditComponent;
  @ContentChild(TransactionSummarySharedComponent)
  summaryCompRef: TransactionSummarySharedComponent;
  constructor(
    @Inject(DOCUMENT) private documents: any,
    private translatePipe: TranslatePipe,
    private timezoneService: TimezoneService,
    private store: Store<AppState>,
    private cookieService: CookieService,
    private transactionService: SalesTransactionService,
    private modalService: NgbModal,
    private renderer: Renderer2,
    private elRef: ElementRef,
    private modalConfig: NgbModalConfig,
    private http: HttpClient,
    private toastr: AlertService,
    private router: Router,
    private locService: locationBroadcastService,
    private offcanvasService: NgbOffcanvas,
    private route: ActivatedRoute,
    private ApiService: ApiService,
    private BreadcrumbService: BreadcrumbService,
    private permissionService: PermissionService,
    private AppAliasService: AppAliasService
  ) {
    this.GLOBALURL = this.ApiService.getBaseURL();
    this.transactionService.GLOBALURL = this.ApiService.getBaseURL();
    this.renderer.listen("window", "click", (e: any) => {
      if (!e.target?.closest("#searchlist")) {
        this.ShowInput = false;
      }
    });
    // Check the URL
    // this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //     // Check if the URL has anything after the /sales/transactions
    //     if (event.urlAfterRedirects.split("/").length > 3) {
    //       this.isLoadData = true;
    //       console.log("HAS_START&END_DATE")
    //       // Get the last 2 parameters from the URL
    //       this.homeStartDateDisplay = event.urlAfterRedirects.split("/")[3];
    //       console.log("SD", this.homeStartDateDisplay)
    //       this.homeEndDateDisplay = event.urlAfterRedirects.split("/")[4];
    //       // console.log("ED", this.ed)
    //       // Also Clear anything after the /sales/transactions
    //     } else {
    //       this.isLoadData = false;
    //       // this.router.navigate(['/sales/transactions']);
    //       // Shift the Logic in ngOnInit
    //     }
    //   }
    // });
  }
  isExportOpen: any = false;
  transactions$: any = [];
  employees$: any = [];
  activeEmployees$: any = [];
  summary$: any = {};
  paymentStatusArray: any = [];
  orderTypes: any = [];
  orderStatusArray: any = [];
  refundOptions: any = [];
  refundReason: any = "";
  noteReason: any = "";
  transactionTimeArray: any[] = [];
  startDate: any = this.timezoneService.get()().startOf("day");
  endDate: any = this.timezoneService.get()().endOf("day");
  // lastStartDate: any = this.timezoneService.get()().startOf('day');
  lastStartDate: any;
  // lastEndDate: any = this.timezoneService.get()().endOf('day');
  lastEndDate: any;
  salesCardNumber: any = "";
  salesCardType: any = "";
  startDateDisplay: any;
  endDateDisplay: any;
  homeStartDateDisplay: any;
  homeEndDateDisplay: any;
  startDateDisplayFormatted: any;
  endDateDisplayFormatted: any;
  options: any = {
    locale: { format: "YYYY-MM-DD" },
    startDate: this.timezoneService.get()().startOf("day"),
    endDate: this.timezoneService.get()().endOf("day"),
    alwaysShowCalendars: true,
    ranges: {
      Today: [this.timezoneService.get()(), this.timezoneService.get()()],
      Yesterday: [
        this.timezoneService.get()().subtract(1, "days"),
        this.timezoneService.get()().subtract(1, "days"),
      ],
      "Last 7 Days": [
        this.timezoneService.get()().subtract(6, "days"),
        this.timezoneService.get()(),
      ],
      "Last 30 Days": [
        this.timezoneService.get()().subtract(29, "days"),
        this.timezoneService.get()(),
      ],
      "This Month": [
        this.timezoneService.get()().startOf("month"),
        this.timezoneService.get()().endOf("month"),
      ],
      "Last Month": [
        this.timezoneService.get()().subtract(1, "month").startOf("month"),
        this.timezoneService.get()().subtract(1, "month").endOf("month"),
      ],
    },
  };
  itemsPP: any = 10;
  p: any = 1;
  userSelected: any;
  account: any = "";
  metaData$: any = {};
  resultEmployeeIds: any = [];
  resultRevenueIds2: any = "";
  resultRevenueIds: any = [];
  currency: any = this.cookieService.get("currency");
  storeIdFixed: any = this.cookieService.get("storeId");
  merchantId: any = this.cookieService.get("merchantId");
  paymentStatusId = "";
  orderSellStatusId = "";
  orderTypeId = "";
  Ruler: Boolean = false;
  pageLoad: Boolean = true;
  // returnUrl: any;
  GLOBALURL: String = this.ApiService.getBaseURL();
  headerToken = {
    "Content-Type": "application/json",
    Authorization: this.cookieService.get("token"),
  };
  httpOptions1 = { headers: new HttpHeaders(this.headerToken) };
  httpOptions2 = {};
  params: any = new HttpParams();
  filterForColumns = [
    {
      index: 0,
      name: "RevenueCenters",
      checked: false,
    },
    {
      index: 1,
      name: "Discounts",
      checked: false,
    },
    {
      index: 2,
      name: "OrderStatus",
      checked: false,
    },
  ];
  NewPaymentStaus = [
    { value: "1", name: "Approved " },
    { value: "2", name: "Partial Refund " },
    { value: "3", name: "Refunded " },
    { value: "4", name: "Refund " },
    { value: "5", name: "Deposited " },
    { value: "6", name: "Void " },
  ];

  NewcardType = [
    { value: "24", name: "Visa" },
    { value: "23", name: "Master Card" },
    { value: "22", name: "Discover" },
    { value: "21", name: "Amex" },
    { value: "25", name: "Unknown" },
  ];
  //location service check if load data
  isLoadData = false;
  // isHomeRedirect = false;
  ngOnInit(): void {
    const element = this.renderer.selectRootElement('.main-content', true);
    this.renderer.setStyle(element, 'overflow', 'hidden');
    if (!this.isSuperAdmin) {
      this.BreadcrumbService.setValue(this.breadcrumbItems);
    }

    if(this.isSuperAdmin) {
      this.merchantId = this.isMerchantId;
      this.storeId = "*";
      this.storeIdFixed = "*";
      // this.storeId = "672db0c26125238d61a71109";
    }   
     this.AppAliasService.getStoreValue().subscribe((res) => {
      if (res === '*') {
        this.toastr.error('Please select a store');
        return;
      }
    }
    );
    // Get and Store the Url from Params
    if (!Boolean(this.currency)) {
      this.currency = "$";
    }
    this.sd = this.route.snapshot.paramMap.get("sd");
    this.ed = this.route.snapshot.paramMap.get("ed");
    console.log("SD", this.sd)
    console.log("ED", this.ed)

    if (this.sd && this.ed) {
      this.isLoadData = true;
    } else {
      this.isLoadData = false;
    }

    // this.sd = this.route.snapshot.paramMap.get("sd");
    // this.ed = this.route.snapshot.paramMap.get("ed");
    // console.log("SD", this.sd)
    // console.log("ED", this.ed)

    // if(this.sd && this.ed){
    //   this.isLoadData = true;
    // } else {
    //   this.isLoadData = false;
    // }
    // if (this.sd) {
    //   this.startDateDisplay = this.sd;
    //   this.startDate = this.timezoneService
    //     .get()
    //     .unix(Number(this.sd))
    //     .startOf("day");
    // } else {
    //   this.startDate = this.timezoneService.get()().startOf("day");
    //   this.startDateDisplay = this.startDate.unix();
    // }

    // if (this.ed) {
    //   this.endDateDisplay = this.ed;
    //   this.endDate = this.timezoneService
    //     .get()
    //     .unix(Number(this.ed))
    //     .endOf("day");
    // } else {
    //   this.endDate = this.timezoneService.get()().endOf("day");
    //   this.endDateDisplay = this.endDate.unix();
    // }

    // this.startDateDisplayFormatted = this.timezoneService
    //   .get()
    //   .unix(this.startDateDisplay)
    //   .format("MMM Do YYYY");
    // this.endDateDisplayFormatted = this.timezoneService
    //   .get()
    //   .unix(this.endDateDisplay)
    //   .format("MMM Do YYYY");

    // this.locService.currentApprovalStageMessage.subscribe(storeId => {
    //   if (storeId) {
    //     this.changeStore(storeId)
    //     this.isLoadData=true
    //   }
    // });
    // if (!this.storeId || this.storeId === '*') {
    //   this.toastr.error('Please select a store');
    //   return;
    // }
    if (this.storeId != "*") {
      this.params = this.params.set("storeId", this.storeId);
      // this.httpOptions = { headers: new HttpHeaders(this.headerToken) };
      this.httpOptions2 = {
        headers: new HttpHeaders(this.headerToken),
        params: this.params,
      };
    } else {
      // this.httpOptions = { headers: new HttpHeaders(this.headerToken) };
      this.httpOptions2 = { headers: new HttpHeaders(this.headerToken) };
    }
    this.modalConfig.backdrop = "static";
    this.modalConfig.keyboard = false;
    // this.getSettings();
    this.getTransactionReport();
    setTimeout(() => {
      const elements = this.documents.querySelectorAll(".daterangepicker");
      elements.forEach((element: any) => {
        // this.renderer.setStyle(element, "z-index", "99");
      });
    }, 1000);
  }

  //  Get Transaction list with condition
  getTransactionReport = async () => {
    // if (this.cookieService.check("permissionNameSalesTransaction")) {
      this.account = this.cookieService.get("loggedAccount");
      // this.getSettings();
      this.store.select(getSalesTransactionSummaryData).subscribe((result) => {
        let response = result;
        this.summary$ = { ...response };
        console.log("Summary$", this.summary$);
      });
      this.store.select(getSalesTransactionEmployeeData).subscribe((result) => {
        let response = result;
        this.employees$ = [...response];
      });
      this.store.select(getActiveEmployees).subscribe((result) => {
        let response = result;
        this.activeEmployees$ = [...response];
        // console.log("this.activeEmployees$", this.activeEmployees$);
      });
      this.store.select(getSalesTransactions).subscribe((result) => {
        let response = result;
        let lastPage = Math.ceil(
          this.metaData$.ordersTotal / this.metaData$.itemsPerPage
        );
        const isLastPage = this.p === lastPage;

        console.log("isLastPage", isLastPage);

        // if (response.length < 10) {
        //   this.p = 1;
        // }

        this.transactions$ = [...response];
        console.log("this.transactions$", this.transactions$);
        setTimeout(() => {
          this.setPaginateTexts();
        }, 100);
      });
      this.store.select(getSalesTransactionMetaData).subscribe((result) => {
        let response = result;
        this.metaData$ = { ...response };
      });
      // this.store.select(getSelectedStoreLocation).subscribe((result) => {
      //   this.currency = result.currency;
      // });
      this.transactionTimeArray = [
        { id: "0", text: "12:00 AM" },
        { id: "1", text: "01:00 AM" },
        { id: "2", text: "02:00 AM" },
        { id: "3", text: "03:00 AM" },
        { id: "4", text: "04:00 AM" },
        { id: "5", text: "05:00 AM" },
        { id: "6", text: "06:00 AM" },
        { id: "7", text: "07:00 AM" },
        { id: "8", text: "08:00 AM" },
        { id: "9", text: "09:00 AM" },
        { id: "10", text: "10:00 AM" },
        { id: "11", text: "11:00 AM" },
        { id: "12", text: "12:00 PM" },
        { id: "13", text: "01:00 PM" },
        { id: "14", text: "02:00 PM" },
        { id: "15", text: "03:00 PM" },
        { id: "16", text: "04:00 PM" },
        { id: "17", text: "05:00 PM" },
        { id: "18", text: "06:00 PM" },
        { id: "19", text: "07:00 PM" },
        { id: "20", text: "08:00 PM" },
        { id: "21", text: "09:00 PM" },
        { id: "22", text: "10:00 PM" },
        { id: "23", text: "11:00 PM" },
        { id: "24", text: "12:00 AM" },
      ];
      this.refundOptions = [
        "QSA",
        "Food Cold",
        "Too Much Salt",
        "Undercooked",
        "OverCooked",
        "Prepared Incorrectly",
        "Food Allergy",
        "Foreign Object in Food",
        "Wrong Menu Item",
        "Out of Stock",
        "Other",
      ];



      if (!this.isLoadData) {
        this.getNumberCountPayments("firstLoad");
        this.getEmployees();
      } else {
        this.getNumberCountPaymentsbyHomeNetSales();
        this.getEmployees();
      }
      //this.getEmployees()
      //this.getNumberCountPayments();
      this.getPaymentMethods();
      this.paymentStatusArray = [
        { id: 1, name: "Approved" },
        { id: 2, name: "Partially refunded" },
        { id: 3, name: "Refunded" },
        { id: 4, name: "Refund" },
        { id: 5, name: "Deposited" },
      ];
      this.orderStatusArray = [
        { id: 3, name: "Paid" },
        { id: 4, name: "Completed" },
        { id: 5, name: "Partially refunded" },
        { id: 6, name: "Refunded" },
      ];
      this.orderTypes = [
        { id: 1, name: "Dine-In" },
        { id: 2, name: "Bar" },
        { id: 3, name: "Takeout" },
        { id: 4, name: "App" },
        { id: 5, name: "Delivery" },
        { id: 6, name: "Ahead" },
        { id: 7, name: "Banquet" },
        { id: 8, name: "Online Ordering" },
        { id: 10, name: "Drive Thru" },
      ];
    // } else {
    //   this.router.navigate(["/dashboard"]);
    // }
  }

  setPaginateTexts() {
    const next = document.querySelector(".pagination-next a");
    const prev = document.querySelector(".pagination-previous a");
    const nextDisabled = document.querySelector(".pagination-next > span");
    const prevDisabled = document.querySelector(".pagination-previous > span");
    console.log("next", next);
    console.log("prev", prev);
    console.log("nextDisabled", nextDisabled);
    console.log("prevDisabled", prevDisabled);

    this.translatePipe.transform("Next")
      .subscribe(res => {
        if (next) {
          next.textContent = res;
        }
        if (nextDisabled) {
          nextDisabled.textContent = res;
        }
      },
      (error) => {});

    this.translatePipe.transform("Previous")
      .subscribe(res => {
        if (prev) {
          prev.textContent = res;
        }
        if (prevDisabled) {
          prevDisabled.textContent = res;
        }
      },
      (error) => {});
  }

  // When the Page is Initialized change the State of the Load Data
  // ngAfterViewInit() {
  //   this.isLoadData = false;
  //   console.log("ISLOADDATA_FROM_AFER-VIEW-INIT", this.isLoadData);
  // }

  async selectedDate(value: any) {
    this.isLoadData = false;
    this.showItemCountPP = 0;
    this.p = 1;
    this.startDate = value.start;
    this.endDate = value.end;
    // this.startDate = "1741579200";
    // this.endDate = "1741665540";
    this.startDateDisplay = this.startDate.unix();
    this.endDateDisplay = this.endDate.unix();
    this.startDateDisplayFormatted = this.timezoneService
      .get()
      .unix(this.startDateDisplay)
      .format("MMM Do YYYY");
    this.endDateDisplayFormatted = this.timezoneService
      .get()
      .unix(this.endDateDisplay)
      .format("MMM Do YYYY");

    const hour = Number(this.startTime.split(["."])[0]) || 0;
    const minutes = this.startTime.split(["."])[1] || 0;
    this.startTimeFormatted = this.timezoneService
      .get()(this.startDate)
      .startOf("day")
      .add(hour, "hours")
      .add(minutes, "minutes")
      .format("HH:mm a");
    this.startDate = this.timezoneService
      .get()(this.startDate)
      .subtract(0, "days")
      .set({ hours: hour })
      .set({ minutes: minutes });

    const hourEnd = Number(this.endTime.split(["."])[0]) || 0;
    const minutesEnd = this.endTime.split(["."])[1] || 0;
    this.endTimeFormatted = this.timezoneService
      .get()(this.endDate)
      .startOf("day")
      .add("hour", hourEnd)
      .add("minutes", minutesEnd)
      .format("HH:mm a");
    this.endDate = this.timezoneService
      .get()(this.endDate)
      .subtract(0, "days")
      .set({ hours: hourEnd })
      .set({ minutes: minutesEnd });

    this.startDateDisplay = this.startDate.format("MMM Do YYYY");
    this.endDateDisplay = this.endDate.format("MMM Do YYYY");

    var startDate = this.timezoneService.get()(this.startDate);
    var endDate = this.timezoneService.get()(this.endDate);
    var totalDays = endDate.diff(startDate, "days");
    if (totalDays == 0) {
      var selectedDate = this.timezoneService.get()(this.startDate);
      this.lastStartDate = selectedDate
        .clone()
        .subtract(1, "days")
        .startOf("day")
        .unix();
      this.lastEndDate = selectedDate
        .clone()
        .subtract(1, "days")
        .endOf("day")
        .unix();
    } else {
      var selectedDate = this.timezoneService.get()(this.startDate);
      this.lastStartDate = selectedDate
        .clone()
        .subtract(totalDays, "days")
        .startOf("day")
        .unix();
      this.lastEndDate = selectedDate
        .clone()
        .subtract(1, "days")
        .endOf("day")
        .unix();
    }

    if (
      this.ClosingDay == "Next Day" &&
      this.startDateDisplay == this.endDateDisplay
    ) {
      window.alert(
        "Same start and end date cannot be selected with Next Day option."
      );
    } else {
      // this.fetchRerport(this.startDate.unix(),this.endDate.unix());
      // this.startDate.unix(),
      // this.endDate.unix()
      await this.getNumberCountPayments();
    }
    // await this.getNumberCountPayments();
  }
  startTime: any = "";
  startTimeFormatted: any = "";
  endTime: any = "";
  endTimeFormatted: any = "";
  clickDayAllOption(): void {
    this.showItemCountPP = 0;
    this.p = 1;
    this.Ruler = false;
    this.startTime = "";
    this.endTime = "";
    this.endTimeFormatted = "";
    this.startTimeFormatted = "";
    this.myDrop.close();
    this.getNumberCountPayments();
  }
  clickCustomizeOption(): void {
    this.Ruler = true;
  }
  // changeStartTimeOrder(e) {
  //   //this.startTime = e;
  //   this.transactionTimeArray.forEach((element) => {
  //     if (element.id == this.startTime) {
  //       this.startTimeFormatted = element.text;
  //       const hour = Number(this.startTime) || 0;
  //       const minutes = 0; // since we dont select mins in drop down
  //       this.startDateDisplay = this.timezoneService
  //         .get()(this.startDate)
  //         .subtract(0, "days")
  //         .set({ hours: hour })
  //         .set({ minutes: minutes })
  //         .unix();
  //     }
  //   });
  //   this.checkTimeOrder();
  // }

  // changeEndTimeOrder(e: any) {
  //   //this.endTime = e;
  //   this.transactionTimeArray.forEach((element) => {
  //     if (element.id == this.endTime) {
  //       this.endTimeFormatted = element.text;
  //       const hour = Number(this.endTime) || 0;
  //       const minutes = 0; // since we dont select mins in drop down
  //       this.endDateDisplay = this.timezoneService
  //         .get()(this.endDate)
  //         .subtract(0, "days")
  //         .set({ hours: hour })
  //         .set({ minutes: minutes })
  //         .unix();
  //     }
  //   });
  //   this.checkTimeOrder();
  // }

  checkTimeOrder() {
    const minHour = 0; // 12:00 AM
    const maxHour = 23; // 11:00 PM

    if (this.startTime !== "" && this.endTime !== "") {
      const startHour = Math.floor(this.startTime);
      const startMinute = (this.startTime - startHour) * 60;

      const endHour = Math.floor(this.endTime);
      const endMinute = (this.endTime - endHour) * 60;

      // Convert start and end times to minutes from midnight for comparison
      const startTimeMinutes = startHour * 60 + startMinute;
      const endTimeMinutes = endHour * 60 + endMinute;

      if (startTimeMinutes != endTimeMinutes) {
        this.p = 1;
        this.showItemCountPP = 0;
        this.myDrop.close();
        this.getNumberCountPayments();
      } else {
        this.toastr.error("Start time should be less than End time.");
      }
    }
  }
  changeStore(event: any): void {
    this.showItemCountPP = 0;
    this.p = 1;
    this.storeId = event;
    this.storeIdFixed = event;
    this.getSettings();
    this.getNumberCountPayments();
    this.getEmployees();
  }

  dateTimeArray: any[] = [];
  ClosingDay = "Same Day";

  getSettings() {
    this.store.dispatch(setLoadingSpinner({ status: true }));
    this.http.get(this.GLOBALURL + "/settings", this.httpOptions2).subscribe(
      (resp: any) => {
        // this.store.dispatch(setLoadingSpinner({ status: false }));
        if (resp.success === 0) {
          this.toastr.error(resp.message);
        } else {
          let hour = 23;
          let minutes = 59;
          let StartOfHourByDay = resp.response.find(
            (el) => el.settingName === "StartOfHourByDay"
          );
          let EndOfHourByDay = resp.response.find(
            (el) => el.settingName === "EndOfHourByDay"
          );
          let ClosingDay = resp.response.find(
            (el) => el.settingName === "ClosingDay"
          );
          if (!StartOfHourByDay || !EndOfHourByDay || !ClosingDay) {
            this.setTimes(0, 0, 23, 30);
            StartOfHourByDay = "00:00";
            EndOfHourByDay = "23:59";
            ClosingDay = "Same Day";
          } else {
            StartOfHourByDay = StartOfHourByDay.settingValue;
            EndOfHourByDay = EndOfHourByDay.settingValue;
            ClosingDay = ClosingDay.settingValue;
          }
          this.ClosingDay = ClosingDay;
          let dateTimeToday = this.timezoneService.get()();
          const startHour = Number(StartOfHourByDay.split([":"])[0]);
          const startMinutes = Number(StartOfHourByDay.split([":"])[1]);
          this.startDate = this.timezoneService
            .get()(this.startDate)
            .set({ hours: startHour })
            .set({ minutes: startMinutes });
          this.startDateDisplay = this.timezoneService
            .get()(this.startDate)
            .format("MMM Do YYYY");
          // this.startDateDisplayFormatted = this.timezoneService
          //   .get()
          //   .unix(this.startDateDisplay)
          //   .format("MMM Do YYYY");

          hour = Number(EndOfHourByDay.split([":"])[0]);
          minutes = Number(EndOfHourByDay.split([":"])[1]);
          this.endDate = this.timezoneService
            .get()(this.endDate)
            .set({ hours: hour })
            .set({ minutes });
          this.endDateDisplay = this.timezoneService
            .get()(this.endDate)
            .format("MMM Do YYYY");
          // this.endDateDisplayFormatted = this.timezoneService
          //   .get()
          //   .unix(this.endDateDisplay)
          //   .format("MMM Do YYYY");

          this.options.startDate = this.startDate;
          /**
           * Current time is within restaurant hours
           * Date set would be today and tomorrow
           */
          // hour = Number(EndOfHourByDay.split([":"])[0]);
          // minutes = Number(EndOfHourByDay.split([":"])[1]);
          // this.endDate = this.timezoneService
          //   .get()(this.endDate)
          //   .add(1, "days")
          //   .set({ hours: hour })
          //   .set({ minutes });
          // this.endDateDisplay = this.timezoneService
          //   .get()(this.endDate)
          //   .format("MMM Do YYYY");

          // this.options.endDate = this.endDate;
          if (
            this.startDate.diff(dateTimeToday) > 0 &&
            this.endDate.diff(dateTimeToday) > 0
          ) {
            /**
             * Current time is before restaurant hours
             * Date set would be yesterday and today
             */
            console.log("yesterday and today");
            this.startDate = this.timezoneService
              .get()(this.startDate)
              .subtract(1, "days");
            this.startDateDisplay = this.timezoneService
              .get()(this.startDate)
              .format("MMM Do YYYY");

            this.options.startDate = this.startDate;
            // this.startDateDisplayFormatted = this.timezoneService
            //   .get()
            //   .unix(this.startDateDisplay)
            //   .format("MMM Do YYYY");
          } else if (
            this.startDate.diff(dateTimeToday) > 0 &&
            this.endDate.diff(dateTimeToday) < 0
          ) {
            console.log("tomorrow and day after tomorrow");
            /**
             * Current time is after restaurant hours
             * Date set would be tomorrow and day after tomorrow
             */
            this.startDate = this.timezoneService
              .get()(this.startDate)
              .add(1, "days");
            this.startDateDisplay = this.timezoneService
              .get()(this.startDate)
              .format("MMM Do YYYY");
            this.options.startDate = this.startDate;
            // this.startDateDisplayFormatted = this.timezoneService
            //   .get()
            //   .unix(this.startDateDisplay)
            //   .format("MMM Do YYYY");
            hour = Number(EndOfHourByDay.split([":"])[0]);
            minutes = Number(EndOfHourByDay.split([":"])[1]);
            this.endDate = this.timezoneService
              .get()(this.endDate)
              .add(2, "days")
              .set({ hours: hour })
              .set({ minutes });
            this.endDateDisplay = this.timezoneService
              .get()(this.endDate)
              .format("MMM Do YYYY");

            this.options.endDate = this.endDate;

            // this.endDateDisplayFormatted = this.timezoneService
            //   .get()
            //   .unix(this.endDateDisplay)
            //   .format("MMM Do YYYY");
            console.log(
              "this.endDateDisplayFormatted",
              this.endDateDisplayFormatted
            );
          } else {
            /**
             * Current time is within restaurant hours
             * Date set would be today and tomorrow
             */
            console.log("today and tomorrow");
            console.log("END OF HOUR BY DAY", EndOfHourByDay);
            hour = Number(EndOfHourByDay.split([":"])[0]);
            minutes = Number(EndOfHourByDay.split([":"])[1]);
            this.endDate = this.timezoneService
              .get()(this.endDate)
              .add(1, "days")
              .set({ hours: hour })
              .set({ minutes });
            this.endDateDisplay = this.timezoneService
              .get()(this.endDate)
              .format("MMM Do YYYY");

            this.options.endDate = this.endDate;

            // this.endDateDisplayFormatted = this.timezoneService
            //   .get()
            //   .unix(this.endDateDisplay)
            //   .format("MMM Do YYYY");
            console.log(
              "this.endDateDisplayFormatted",
              this.endDateDisplayFormatted
            );
          }
          this.setTimes(startHour, startMinutes, hour, minutes);
          if (this.ClosingDay === "Same Day") {
            hour = Number(EndOfHourByDay.split([":"])[0]);
            minutes = Number(EndOfHourByDay.split([":"])[1]);
            this.endDate = this.timezoneService
              .get()(this.startDate)
              .add(0, "days")
              .set({ hours: hour })
              .set({ minutes });
            this.options.endDate = this.options.startDate;
            this.endDateDisplay = this.timezoneService
              .get()(this.options.endDate)
              .format("MMM Do YYYY");

            // this.endDateDisplayFormatted = this.timezoneService
            //   .get()
            //   .unix(this.endDateDisplay)
            //   .format("MMM Do YYYY");
            console.log(
              "this.endDateDisplayFormatted",
              this.endDateDisplayFormatted
            );
          }
        }
        // this.getNumberCountPayments();
        // this.getEmployees();
        // this.loadPage();
        // this.getNumberCountPayments();
      },
      (error) => {
        this.store.dispatch(setLoadingSpinner({ status: false }));
        const message = this.ApiService.errorMessage(error);
        this.toastr.error(message);
      }
    );
  }

  setTimes(
    startHour: number,
    startMinutes: number,
    endHour: number,
    endMinutes: number
  ) {
    this.dateTimeArray = [];
    startHour = 0;
    startMinutes = 0;
    endHour = 23;
    endMinutes = 60;
    for (let time = 0; time <= 23; time++) {
      let dateTime = this.timezoneService.get()().startOf("day");
      if (time >= startHour && time <= endHour) {
        dateTime.add(time, "hour");
        this.dateTimeArray.push({
          id: time.toString(),
          text: time <= 9 ? `0${time}:00` : `${time}:00`,
        });
        if (time + 1 > endHour) {
          if (60 <= endMinutes) {
            for (let index = 1; index < 59; index++) {
              let minutes = index <= 9 ? `0${index}` : index;
              this.dateTimeArray.push({
                id: `${time}.${index}`,
                text: time <= 9 ? `0${time}:${minutes}` : `${time}:${minutes}`,
              });
            }
            this.dateTimeArray.push({
              id: `${time}.59`,
              text: time <= 9 ? `0${time}:59` : `${time}:59`,
            });
            break;
          }
        }
        if (60 <= endMinutes) {
          for (let index = 1; index <= 59; index++) {
            let minutes = index <= 9 ? `0${index}` : index;
            this.dateTimeArray.push({
              id: `${time}.${index}`,
              text: time <= 9 ? `0${time}:${minutes}` : `${time}:${minutes}`,
            });
          }
        }
      }
    }
    let timeStart = this.startDate.format("HH:mm");
    let timeEnd = this.endDate.format("HH:mm");
    this.startTimeFormatted = this.startDate.format("HH:mm a");
    this.endTimeFormatted = this.endDate.format("HH:mm a");
    console.log("timeStart", this.startTimeFormatted);
    console.log("timeEnd", this.endTimeFormatted);
    this.startTime = this.dateTimeArray.find((x) => x.text === timeStart).id;
    this.endTime = this.dateTimeArray.find((x) => x.text === timeEnd).id;

    // if (!this.isLoadData) {
    //   this.getNumberCountPayments();
    //   this.getEmployees();
    // }
  }

  sameDayIsChecked() {
    return this.ClosingDay === "Same Day";
  }
  nextDayIsChecked() {
    return this.ClosingDay === "Next Day";
  }
  selectClosingDay($event) {
    console.log("ClosingDay", $event);
    this.ClosingDay = $event;
  }

  timeFilter() {
    this.isLoadData = false;
    this.changeStartTimeOrder();
    this.changeEndTimeOrder();
  }

  changeStartTimeOrder() {
    const hour = Number(this.startTime.split(["."])[0]) || 0;
    const minutes = this.startTime.split(["."])[1] || 0;
    this.startTimeFormatted = this.timezoneService
      .get()(this.startDate)
      .startOf("day")
      .add(hour, "hours")
      .add(minutes, "minutes")
      .format("HH:mm a");
    this.startDate = this.timezoneService
      .get()(this.startDate)
      .subtract(0, "days")
      .set({ hours: hour })
      .set({ minutes: minutes });
    console.log("startTime", this.startTimeFormatted, this.startDate);
  }
  changeEndTimeOrder() {
    const hour = Number(this.endTime.split(["."])[0]) || 0;
    const minutes = this.endTime.split(["."])[1] || 0;
    this.endTimeFormatted = this.timezoneService
      .get()(this.endDate)
      .startOf("day")
      .add("hour", hour)
      .add("minutes", minutes)
      .format("HH:mm a");
    //change subtract
    this.endDate = this.timezoneService
      .get()(this.endDate)
      .subtract(0, "days")
      .set({ hours: hour })
      .set({ minutes: minutes });
    console.log("endTime", this.endTimeFormatted, this.endDate, hour, minutes);
    this.checkTimeOrder();
  }
  timeDiasbleValidation() {
    const startHour = Number(this.startTime?.split(["."])?.[0]) || 0;
    const startMinutes = this.startTime?.split(["."])?.[1] || 0;
    const time1 = this.timezoneService
      .get()(this.startDate)
      .startOf("day")
      .add(startHour, "hours")
      .add(startMinutes, "minutes")
      .format("HH:mm");
    // console.log("time1", time1)

    const endhour = Number(this.endTime?.split(["."])?.[0]) || 0;
    const endMinutes = this.endTime?.split(["."])?.[1] || 0;
    const time2 = this.timezoneService
      .get()(this.endDate)
      .startOf("day")
      .add("hour", endhour)
      .add("minutes", endMinutes)
      .format("HH:mm");
    // console.log("time2", time2)
    // const time1 = this.startDate.text;
    // const time2 = this.endDate.text;

    // Parse the time strings to create Date objects
    const date1 = new Date(`1970-01-01T${time1}`);
    const date2 = new Date(`1970-01-01T${time2}`);

    // Compare the dates
    if (date1 < date2) {
      return false;
    } else {
      return true;
    }
  }

  data: any = {};
  async fetchingSummary() {
    var startDate = this.timezoneService.get()(this.startDate);
    var endDate = this.timezoneService.get()(this.endDate);
    var totalDays = endDate.diff(startDate, "days");
    if (totalDays == 0) {
      var selectedDate = this.timezoneService.get()(this.startDate);
      this.lastStartDate = selectedDate
        .clone()
        .subtract(1, "days")
        .startOf("day")
        .unix();
      this.lastEndDate = selectedDate
        .clone()
        .subtract(1, "days")
        .endOf("day")
        .unix();
    } else {
      var selectedDate = this.timezoneService.get()(this.startDate);
      this.lastStartDate = selectedDate
        .clone()
        .subtract(totalDays, "days")
        .startOf("day")
        .unix();
      this.lastEndDate = selectedDate
        .clone()
        .subtract(1, "days")
        .endOf("day")
        .unix();
    }

    let startDateFormat = this.startDate.unix();
    let endDateFormat = this.endDate.unix();
    console.log("startDateFormat", startDateFormat);
    console.log("endDateFormat", endDateFormat);

    let startTime = this.timezoneService
      .get()
      .unix(this.startDateDisplay)
      .format("HH:mm");

    let endTime = this.timezoneService
      .get()
      .unix(this.endDateDisplay)
      .format("HH:mm");

    this.data = {
      resultEmployeeIds: this.resultEmployeeIds,
      resultRevenueIds: this.resultRevenueIds,
      startDate: this.startDate,
      endDate: this.endDate,
      startTime: startTime,
      endTime: endTime,
      startDateDisplay: this.startDateDisplay,
      endDateDisplay: this.endDateDisplay,
      merchantId: this.merchantId,
      storeIdFixed: this.storeIdFixed,
      paymentStatusId: this.paymentStatusId,
      pageLoad: this.pageLoad,
      orderSellStatusId: this.orderSellStatusId,
      orderTypeId: this.orderTypeId,
      lastStartDate: this.lastStartDate,
      lastEndDate: this.lastEndDate,
      salesCardNumber: this.salesCardNumber,
      salesCardType: this.salesCardType,
    };
    console.log("QUERY_PAYLOAD_DATA", this.data);
    this.store.dispatch(salesTransactionsSummaryFetchStart(this.data));
    // console.log("fetchSummary2", this.data);
  }

  // Fetch Summary From Home Net Sales
  async fetchingSummarybyHomeNetSales() {
    var startDate = this.timezoneService.get()(this.startDate);
    // this.startDate = this.timezoneService
    //       .get()
    //       .unix(this.startDateDisplay);
    // .format("MMM Do YYYY");
    // var startDate = this.timezoneService.get()(this.startDate);
    var endDate = this.timezoneService.get()(this.endDate);
    // this.endDate = this.timezoneService
    //       .get()
    //       .unix(this.endDateDisplay);
    //       var endDate = this.timezoneService.get()(this.endDate);
    console.log("startDate_FROM_QUERY", startDate);
    console.log("endDate_FROM_QUERY", endDate);
    var totalDays = endDate.diff(startDate, "days");
    if (totalDays == 0) {
      var selectedDate = this.timezoneService.get()(this.startDate);
      this.lastStartDate = selectedDate
        .clone()
        .subtract(1, "days")
        .startOf("day")
        .unix();
      this.lastEndDate = selectedDate
        .clone()
        .subtract(1, "days")
        .endOf("day")
        .unix();
    } else {
      var selectedDate = this.timezoneService.get()(this.startDate);
      this.lastStartDate = selectedDate
        .clone()
        .subtract(totalDays, "days")
        .startOf("day")
        .unix();
      this.lastEndDate = selectedDate
        .clone()
        .subtract(1, "days")
        .endOf("day")
        .unix();
    }

    let startDateFormat = this.startDate.unix();
    let endDateFormat = this.endDate.unix();
    console.log("startDateFormat", startDateFormat);
    console.log("endDateFormat", endDateFormat);
    this.data = {
      resultEmployeeIds: this.resultEmployeeIds,
      resultRevenueIds: this.resultRevenueIds,
      startDate: this.startDate,
      endDate: this.endDate,
      startTime: this.startTime,
      endTime: this.endTime,
      startDateDisplay: this.startDateDisplay,
      endDateDisplay: this.endDateDisplay,
      merchantId: this.merchantId,
      storeIdFixed: this.storeIdFixed,
      paymentStatusId: this.paymentStatusId,
      pageLoad: this.pageLoad,
      orderSellStatusId: this.orderSellStatusId,
      orderTypeId: this.orderTypeId,
      lastStartDate: this.lastStartDate,
      lastEndDate: this.lastEndDate,
      salesCardNumber: this.salesCardNumber,
      salesCardType: this.salesCardType,
    };
    console.log("QUERY_PAYLOAD_DATA", this.data);
    this.isLoadData = false;
    this.store.dispatch(salesTransactionsSummaryFetchStart(this.data));
    // console.log("fetchSummary2", this.data);
  }
  paymentMethods: any = [];

  getPaymentMethods() {
    this.paymentMethods = [
      { id: 1, name: "Cash" },
      // {id: 2,name:'Cheque Payment'},
      { id: 3, name: "BruinCard" },
      { id: 4, name: "Givex" },
      // {id: 5,name:'UCLA Blood'},
      // {id: 6,name:'UCLA Career'},
      // {id: 7,name:'UCLA Dorm'},
      // {id: 8,name:'UCLA Emp'},
      // {id: 9,name:'UCLA Meal'},
      // {id: 10,name:'UCLA Parent'},
      // {id: 11,name:'UCLA Events'},
      // {id: 12,name:'GC Promotion'},
      { id: 13, name: "Grub Hub" },
      // { id: 14, name: "Postmates" },
      { id: 14, name: "Uber Eats" },
      { id: 15, name: "Account" },
      // {id: 16,name:'CardConnect Payment'},
      //{id: 17,name:'DataCap Payment'},
      //{id: 18,name:'Card Payment'},
      //{id: 19,name:'UNO App'},
      { id: 20, name: "Square" },
      { id: 21, name: "Amex" },
      { id: 22, name: "Discover" },
      { id: 23, name: "Mastercard" },
      { id: 24, name: "Visa" },
      { id: 26, name: "Doordash" },
      { id: 27, name: "Blizzful" },
      { id: 29, name: "Clover" },
      { id: 31, name: "eCard" },
      // { id: 32, name: "Online Order" },
      { id: 33, name: "Voucherify" },
      // { id: 34, name: "Ubereats" },
      { id: 35, name: "External CC" },
      { id: 36, name: "Otter" },
      { id: 37, name: "TotalPay" },
      { id: 33, name: "Loyalty points" },
      { id: 38, name: "Adyen" }

    ];
  }
  itemChecked: any = false;
  checkedAll: boolean = false;
  checkAllRows() {
    this.isLoadData = false;
    this.offcanvasService.dismiss("cross click");
    this.p = 1;
    this.showItemCountPP = 0;
    this.resultRevenueIds = [];
    for (var i = 0; i < this.paymentMethods.length; i++) {
      this.resultRevenueIds.push(this.paymentMethods[i].id);
    }
    this.itemChecked = true;
    this.resultRevenueIds2 = this.resultRevenueIds.join(",");
    this.getNumberCountPayments();
  }
  findPaymentCheck = (paymentMethodId) => {
    const paymentCheck = this.resultRevenueIds.filter(
      (x) => x === paymentMethodId
    );
    return paymentCheck.length > 0 ? true : false;
  };
  uncheckAllRows() {
    this.isLoadData = false;
    this.offcanvasService.dismiss("cross click");
    this.p = 1;
    this.showItemCountPP = 0;
    this.resultRevenueIds = [];
    this.itemChecked = false;
    this.resultRevenueIds2 = this.resultRevenueIds.join(",");
    this.getNumberCountPayments();
  }
  rowSelected(element: HTMLInputElement, id) {
    this.isLoadData = false;
    this.offcanvasService.dismiss("cross click");
    this.p = 1;
    this.showItemCountPP = 0;

    if (element.checked) {
      let copyR = [...this.resultRevenueIds];
      console.log("copyr all else", copyR);

      copyR = [...copyR, id];
      this.resultRevenueIds = copyR;
    } else {
      let copyR = [...this.resultRevenueIds];
      console.log("copyr all else", copyR);

      copyR = [...copyR.filter((x) => x != id)];
      this.resultRevenueIds = copyR;
    }
    this.resultRevenueIds2 = this.resultRevenueIds.join(",");
    this.getNumberCountPayments();
  }
  storeId: any = this.cookieService.get("storeId");
  getEmployees() {
    // const superAdminPayload = {
    //   merchantId: this.merchantId,
    //   storeId: this.storeId,
    // };
    this.store.dispatch(salesTransactionEmployeeFetchStart());
  }
  filterByUniqEmployees = (employees) => {
    return _.uniqBy(employees, "id");
  };
  resultPaymentsNames: any = "";
  resultEmployeeName: any = [];
  rowSelectedEmployee(element: HTMLInputElement, id, name: any) {
    this.isLoadData = false;
    this.p = 1;
    this.showItemCountPP = 0;
    if (element.checked) {
      let copyR = [...this.resultEmployeeIds];
      copyR = [...copyR, id];
      this.resultEmployeeIds = copyR;

      let copyName = [...this.resultEmployeeName];
      copyName = [...copyName, name];
      this.resultEmployeeName = copyName;
    } else {
      let copyR = [...this.resultEmployeeIds];
      copyR = [...copyR.filter((x) => x != id)];
      this.resultEmployeeIds = copyR;

      let copyName = [...this.resultEmployeeName];
      copyName = [...copyName.filter((x) => x != name)];
      this.resultEmployeeName = copyName;
    }
    this.resultPaymentsNames = this.resultEmployeeIds.join(",");
    this.finalresultPaymentsNames = this.resultEmployeeName.join(",");

    this.getNumberCountPayments();
    // this.fillterData();
    this.offcanvasService.dismiss("cross click");
  }
  fillterData() {
    this.activeEmployees$ = this.activeEmployees$.filter((data) => {
      console.log("data", data);
    });
  }

  itemChecked2: any = false;
  checkedAll2: boolean = false;
  finalresultPaymentsNames: any = "";
  checkAllRowsEmployees() {
    this.isLoadData = false;
    this.p = 1;
    this.showItemCountPP = 0;
    this.resultEmployeeIds = [];
    for (var i = 0; i < this.employees$.length; i++) {
      this.resultEmployeeIds.push(this.employees$[i].id);
      this.resultEmployeeName.push(this.employees$[i].name);
    }
    this.itemChecked2 = true;
    this.resultPaymentsNames = this.resultEmployeeIds.join(",");
    this.finalresultPaymentsNames = this.resultEmployeeName.join(",");

    this.getNumberCountPayments();
    this.offcanvasService.dismiss("cross click");
  }

  uncheckAllRowsEmployees() {
    this.isLoadData = false;
    this.p = 1;
    this.showItemCountPP = 0;
    this.resultEmployeeIds = [];
    this.resultEmployeeName = [];
    this.itemChecked2 = false;
    this.finalresultPaymentsNames = "";
    this.resultPaymentsNames = this.resultEmployeeIds.join(",");
    // this.finalresultPaymentsNames = this.resultEmployeeIds.join(",");

    this.getNumberCountPayments();
    this.offcanvasService.dismiss("cross click");
  }
  findEmployeeCheck(id: any) {
    const employeeCheck = this.resultEmployeeIds.filter((x) => x === id);
    return employeeCheck.length > 0 ? true : false;
  }
  cardTypeFilter: any = "cardType";
  // salesCardNumber: any = "";
  // salesCardType: any = "";
  //change card type
  NewchangeCardFilter(e: any) {
    if (e === "1") {
      this.cardTypeFilter = "cardType";
      this.salesCardType = "";
      this.SelectedCardType = "";
      // this.offcanvasService.dismiss("cross click");
      this.OpenDetails = 'cardtype'
    } else if (e === "2") {
      this.cardTypeFilter = "cardNumber";
      this.salesCardNumber = "";
      this.OpenDetails = "mainMenu";
    }

  }
  changeCardFilter(e: any) {
    if (e.target.value == 1) {
      this.cardTypeFilter = "cardType";
      this.salesCardType = "";
      this.SelectedCardType = "";
    } else if (e.target.value == 2) {
      this.cardTypeFilter = "cardNumber";
      this.salesCardNumber = "";
    }
  }
  closeFiltercanvas() {
    this.offcanvasService.dismiss("cross click");
    this.OpenDetails = "mainMenu";
  }
  NewchangePaymentstatus(e: any) {
    this.paymentStatusId = e;
    this.getNumberCountPayments();
    this.closeFiltercanvas();
  }
  changePaymentstatus(e: any) {
    this.isLoadData = false;
    this.paymentStatusId = e.target.value;
    this.p = 1;
    this.showItemCountPP = 0;
    console.log("itemsPP", this.itemsPP);
    console.log("showItemCountPP", this.showItemCountPP);
    console.log("metaData", this.metaData$);
    this.getNumberCountPayments();
  }

  FilterForCard(e, value) {
    this.isLoadData = false;
    if (e.trim() != "") {
      if (this.cardTypeFilter == "cardNumber") {
        this.salesCardType = "";
        this.SelectedCardType = "";
        const regex = /^[0-9]+$/;
        if (e.length == 4 && regex.test(e)) {
          this.salesCardNumber = e;
          this.getNumberCountPayments();
        } else {
          this.deleteWord(e);
        }
      }
    } else if (e === "") {
      this.salesCardType = "";
      this.SelectedCardType = "";
      this.salesCardNumber = "";
      this.getNumberCountPayments();
    }
    console.log("check value ====>", e);
    const estring = e.toString();
    const elength = estring.length;

    if (elength === 4) {
      this.closeFiltercanvas();
    }
  }

  SelectedCardType: any = "";
  NewFilterByCardType(e: any) {
    const val = e;
    this.salesCardNumber = "";
    this.salesCardType = val;
    this.SelectedCardType = val;
    this.getNumberCountPayments();
    this.closeFiltercanvas();
  }
  FilterByCardType(e) {
    this.isLoadData = false;
    this.p = 1;
    const val = e.target.value;
    this.salesCardNumber = "";
    this.salesCardType = val;
    this.SelectedCardType = val;
    this.getNumberCountPayments();
    if (this.p === 1) {
      this.showItemCountPP = 0;
    } else {
      this.showItemCountPP = this.p * this.itemsPP - this.itemsPP;
    }
  }

  async timeout(ms: any) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  async getPaymentByPaymentStatus(e: any) {
    this.showItemCountPP = 0;
    this.p = 1;
    this.paymentStatusId = e.target.value;
    this.getNumberCountPayments();
  }
  async getPaymentByPaymentStatusOrder(e: any) {
    this.showItemCountPP = 0;
    this.p = 1;
    this.orderSellStatusId = e.target.value;
    this.getNumberCountPayments();
  }
  back: any = [];

  deleteWord(e) {
    if (e.code == "Backspace") {
      this.back.push(e.code);
    } else {
      this.back = [];
    }
    // console.log(e);
    // console.log(this.salesCardNumber);
    // e = e.target.value;
    if (this.cardTypeFilter == "cardNumber") {
      if ((e.length == 0 || e == "") && this.back.length == 1) {
        this.salesCardNumber = "";
        this.getNumberCountPayments();
      }
    } else if (this.cardTypeFilter == "cardType") {
      if (e == "") {
        this.salesCardType = "";
        this.getNumberCountPayments();
      }
    }
  }
  getPaymentByOrderType(e: any) {
    this.showItemCountPP = 0;
    this.p = 1;
    this.orderTypeId = e.target.value;
    this.getNumberCountPayments();
  }
  serviceChargeId: any = "";
  revenueCenterId: any = "";
  firstLoad: Boolean = true;
  async getNumberCountPayments(state?: any) {
    this.store.dispatch(setLoadingSpinner({ status: true }));
    this.startDateDisplay = this.startDate.unix();
    this.endDateDisplay = this.endDate.unix();
    // let startTimeDateValue = this.startDate.unix();
    // let endTimeDateValue = this.endDate.unix();
    // console.log("this.startDateDisplay", this.startDateDisplay);
    // console.log("this.endDateDisplay", this.endDateDisplay);
    // console.log("this.endTimeFormatted", this.endTimeFormatted);

    if (state === "firstLoad") {
      console.log("THIS_IS_FIRST_LOAD");
      let StartOfHourByDay: any = localStorage.getItem("StartOfHourByDay");
      let EndOfHourByDay: any = localStorage.getItem("EndOfHourByDay");
      let ClosingDayValue: any = localStorage.getItem("ClosingDay");

      // const startHour =  Number(StartOfHourByDay.split([":"])[0]);
      // add ternary operator error handling
      const startHour = StartOfHourByDay ? Number(StartOfHourByDay.split([":"])[0]) : 0;
      // const startMinutes = Number(StartOfHourByDay.split([":"])[1]);
      const startMinutes = StartOfHourByDay ? Number(StartOfHourByDay.split([":"])[1]) : 0;

      console.log("startHour", startHour);
      console.log("startMinutes", startMinutes);
      // let startDateWithTime = this.getCustomDate(this.startDate, startHour, startMinutes);
      this.startDate = this.timezoneService
        .get()(this.startDate)
        .hour(startHour)
        .minute(startMinutes);
      this.startDateDisplay = this.timezoneService
        .get()(this.startDate)
        .format("MMM Do YYYY");
      this.startTimeFormatted = this.startDate.format("HH:mm a");
      // console.log("this.startTimeFormatted", this.startTimeFormatted);
      // console.log("THIS>startDate", this.startDate.unix())
      // let hour = Number(EndOfHourByDay.split([":"])[0]);
      let hour = EndOfHourByDay ? Number(EndOfHourByDay.split([":"])[0]) : 23;
      // let minutes = Number(EndOfHourByDay.split([":"])[1]);
      let minutes = EndOfHourByDay ? Number(EndOfHourByDay.split([":"])[1]) : 59;
      this.endDate = this.timezoneService
        .get()(this.endDate)
        .hour(hour)
        .minute(minutes);
      this.endTimeFormatted = this.endDate.format("HH:mm a");
      this.endDateDisplay = this.timezoneService
        .get()(this.endDate)
        .format("MMM Do YYYY");

      this.options.startDate = this.startDate;

      this.ClosingDay = ClosingDayValue;
      let dateTimeToday = this.timezoneService.get()();
      if (
        this.startDate.diff(dateTimeToday) > 0 &&
        this.endDate.diff(dateTimeToday) > 0
      ) {
        /**
         * Current time is before restaurant hours
         * Date set would be yesterday and today
         */
        console.log("yesterday and today");
        this.startDate = this.timezoneService
          .get()(this.startDate)
          .subtract(1, "days");
        this.startDateDisplay = this.timezoneService
          .get()(this.startDate)
          .format("MMM Do YYYY");

        this.options.startDate = this.startDate;
        this.startDateDisplayFormatted = this.timezoneService
          .get()
          .unix(this.startDateDisplay)
          .format("MMM Do YYYY");
      } else if (
        this.startDate.diff(dateTimeToday) > 0 &&
        this.endDate.diff(dateTimeToday) < 0
      ) {
        console.log("tomorrow and day after tomorrow");
        /**
         * Current time is after restaurant hours
         * Date set would be tomorrow and day after tomorrow
         */
        this.startDate = this.timezoneService
          .get()(this.startDate)
          .add(1, "days");
        this.startDateDisplay = this.timezoneService
          .get()(this.startDate)
          .format("MMM Do YYYY");
        this.options.startDate = this.startDate;
        this.startDateDisplayFormatted = this.timezoneService
          .get()
          .unix(this.startDateDisplay)
          .format("MMM Do YYYY");

        hour = EndOfHourByDay ? Number(EndOfHourByDay.split([":"])[0]) : 23;
        minutes = EndOfHourByDay ? Number(EndOfHourByDay.split([":"])[1]) : 59;
        this.endDate = this.timezoneService
          .get()(this.endDate)
          .add(2, "days")
          .set({ hours: hour })
          .set({ minutes });
        this.endDateDisplay = this.timezoneService
          .get()(this.endDate)
          .format("MMM Do YYYY");

        this.options.endDate = this.endDate;

        this.endDateDisplayFormatted = this.timezoneService
          .get()
          .unix(this.endDateDisplay)
          .format("MMM Do YYYY");
        console.log(
          "this.endDateDisplayFormatted",
          this.endDateDisplayFormatted
        );
      } else {
        /**
         * Current time is within restaurant hours
         * Date set would be today and tomorrow
         */
        console.log("today and tomorrow");
        hour = EndOfHourByDay ? Number(EndOfHourByDay.split([":"])[0]) : 23;
        minutes = EndOfHourByDay ? Number(EndOfHourByDay.split([":"])[1]) : 59;
        this.endDate = this.timezoneService
          .get()(this.endDate)
          .add(1, "days")
          .set({ hours: hour })
          .set({ minutes });
        this.endDateDisplay = this.timezoneService
          .get()(this.endDate)
          .format("MMM Do YYYY");

        this.options.endDate = this.endDate;

        this.endDateDisplayFormatted = this.timezoneService
          .get()
          .unix(this.endDateDisplay)
          .format("MMM Do YYYY");
        console.log(
          "this.endDateDisplayFormatted",
          this.endDateDisplayFormatted
        );
      }

      this.setTimes(startHour, startMinutes, hour, minutes);
      if (this.ClosingDay === "Same Day") {
        hour = EndOfHourByDay ? Number(EndOfHourByDay.split([":"])[0]) : 23;
        minutes = EndOfHourByDay ? Number(EndOfHourByDay.split([":"])[1]) : 59;
        this.endDate = this.timezoneService
          .get()(this.startDate)
          .add(0, "days")
          .set({ hours: hour })
          .set({ minutes });
        this.options.endDate = this.options.startDate;
        this.endDateDisplay = this.timezoneService
          .get()(this.options.endDate)
          .format("MMM Do YYYY");

        this.endDateDisplayFormatted = this.timezoneService
          .get()
          .unix(this.endDateDisplay)
          .format("MMM Do YYYY");
        console.log(
          "this.endDateDisplayFormatted",
          this.endDateDisplayFormatted
        );
      }

      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      console.log("this.startDateDisplay222", this.startDateDisplay);
      console.log("this.endDateDisplay222", this.endDateDisplay);
    }
    this.startDateDisplayFormatted = this.timezoneService
      .get()
      .unix(this.startDateDisplay)
      .format("MMM Do YYYY");
    console.log(
      "this.startDateDisplayFormatted",
      this.startDateDisplayFormatted
    );
    this.endDateDisplayFormatted = this.timezoneService
      .get()
      .unix(this.endDateDisplay)
      .format("MMM Do YYYY");
    console.log("this.endDateDisplayFormatted", this.endDateDisplayFormatted);

    let startTime = this.timezoneService
      .get()
      .unix(this.startDateDisplay)
      .format("HH:mm");

    let endTime = this.timezoneService
      .get()
      .unix(this.endDateDisplay)
      .format("HH:mm");

    console.log("START TIME", startTime);
    console.log("END TIME", endTime);

    var data = {
      resultEmployeeIds: this.resultEmployeeIds,
      resultRevenueIds: this.resultRevenueIds,
      startDate: this.startDate,
      endDate: this.endDate,
      startTime: startTime,
      endTime: endTime,
      startDateDisplay: this.startDateDisplay,
      endDateDisplay: this.endDateDisplay,
      merchantId: this.merchantId,
      storeIdFixed: this.storeIdFixed,
      paymentStatusId: this.paymentStatusId,
      pageLoad: this.pageLoad,
      orderSellStatusId: this.orderSellStatusId,
      orderTypeId: this.orderTypeId,
      page: this.p,
      items: this.itemsPP,
      resultPaymentsNames: this.resultPaymentsNames,
      salesCardNumber: this.salesCardNumber,
      salesCardType: this.salesCardType,
      resultRevenueIds2: this.resultRevenueIds2,
      serviceCharge: false,
      serviceChargeId: this.serviceChargeId,
      revenueCenterId: this.revenueCenterId,
      
      // paymentStatus:this.paymentStatus,
    };

    console.log("getNumbersCount", data);
    await this.fetchTransactions(data);
    await this.fetchingSummary();
    this.firstLoad = false;
  }

  // When USer Rediredted to Transaction Detail Page from Home Net Sales
  async getNumberCountPaymentsbyHomeNetSales(state?: any) {
    this.store.dispatch(setLoadingSpinner({ status: true }));
    this.startDateDisplay = Number(this.sd);
    this.endDateDisplay = Number(this.ed);
    this.startDate = this.timezoneService
      .get()
      .unix(this.startDateDisplay)
    this.options.startDate = this.startDate;

    this.endDate = this.timezoneService
      .get()
      .unix(this.endDateDisplay)
    // .startOf("day");
    this.options.endDate = this.endDate;
    console.log("this.startDateDisplay", typeof (this.startDateDisplay));
    console.log("this.endDateDisplay", typeof (this.endDateDisplay));
    // this.startDate = this.timezoneService
    //       .get()
    //       .unix(this.startDateDisplay)
    //       .format("MMM Do YYYY");
    //       this.options.startDate = this.startDate;

    let StartOfHourByDay: any = localStorage.getItem("StartOfHourByDay");
    let EndOfHourByDay: any = localStorage.getItem("EndOfHourByDay");
    let ClosingDayValue: any = localStorage.getItem("ClosingDay");
    const startHour = StartOfHourByDay ? Number(StartOfHourByDay.split([":"])[0]) : 0;
    const startMinutes = StartOfHourByDay ? Number(StartOfHourByDay.split([":"])[1]) : 0;

    let hour = EndOfHourByDay ? Number(EndOfHourByDay.split([":"])[0]) : 23;
    let minutes = EndOfHourByDay ? Number(EndOfHourByDay.split([":"])[1]) : 59;
    this.ClosingDay = ClosingDayValue;
    this.setTimes(startHour, startMinutes, hour, minutes);

    // this.startDateDisplay = this.startDate.unix();
    // this.endDateDisplay = this.endDate.unix();
    this.startDateDisplayFormatted = this.timezoneService
      .get()
      .unix(this.startDateDisplay)
      .format("MMM Do YYYY");
    console.log(
      "this.startDateDisplayFormatted",
      this.startDateDisplayFormatted
    );
    this.endDateDisplayFormatted = this.timezoneService
      .get()
      .unix(this.endDateDisplay)
      .format("MMM Do YYYY");
    console.log("this.endDateDisplayFormatted", this.endDateDisplayFormatted);

    let startTime = this.timezoneService
      .get()
      .unix(this.startDateDisplay)
      .format("HH:mm");

    let endTime = this.timezoneService
      .get()
      .unix(this.endDateDisplay)
      .format("HH:mm");

    var data = {
      resultEmployeeIds: this.resultEmployeeIds,
      resultRevenueIds: this.resultRevenueIds,
      startDate: this.startDate,
      endDate: this.endDate,
      startTime: startTime,
      endTime: endTime,
      startDateDisplay: this.startDateDisplay,
      endDateDisplay: this.endDateDisplay,
      merchantId: this.merchantId,
      storeIdFixed: this.storeIdFixed,
      paymentStatusId: this.paymentStatusId,
      pageLoad: this.pageLoad,
      orderSellStatusId: this.orderSellStatusId,
      orderTypeId: this.orderTypeId,
      page: this.p,
      items: this.itemsPP,
      resultPaymentsNames: this.resultPaymentsNames,
      salesCardNumber: this.salesCardNumber,
      salesCardType: this.salesCardType,
      resultRevenueIds2: this.resultRevenueIds2,
      serviceCharge: false,
      serviceChargeId: this.serviceChargeId,
      revenueCenterId: this.revenueCenterId,
      // paymentStatus:this.paymentStatus,
    };

    console.log("getNumbersCount", data);
    await this.fetchTransactions(data);
    // await this.fetchingSummary();
    await this.fetchingSummarybyHomeNetSales();
    this.firstLoad = false;
  }
  async fetchTransactions(data: any) {
    this.store.dispatch(salesTransactionFetchStart(data));
    console.log("fetchTransactions count", this.transactions$.length);
  }
  floatnumber(a) {
    +a;
    return Number(Math.round(a * 100) / 100).toFixed(2);
  }
  onLimitSelected(e: any) {
    this.p = 1;
    this.itemsPP = e;
    this.showItemCountPP = 0;
    this.getNumberCountPayments();
  }
  showItemCountPP: any = 0;
  //update page
  updatePage = (event: any) => {
    console.log("Page event: ", event);
    this.p = event;
    if (this.p === 1) {
      this.showItemCountPP = 0;
    } else {
      this.showItemCountPP = this.p * this.itemsPP - this.itemsPP;
    }
    this.getNumberCountPayments();
  };
  toggleTable(j) {
    var a = j + this.itemsPP * (this.p - 1);
    let copyR = JSON.parse(JSON.stringify(this.transactions$));
    copyR[j].toggle = !copyR[j].toggle;
    this.transactions$ = copyR;
  }
  /**
   * Open modal
   * @param content modal content
   */
  checkingComponent = "transactions";
  paymentReceipt: any = {};
  paymentReceiptCopy: any = {};
  selectedTotal = 0;
  index: any = -1;
  deliveryFee: any;
  promoCodeValue: any;
  modifierValidation: any = "0";
  editOrdenSecondStep: boolean = false;
  seePaymentReceipt(content: any, payment: any, j: any) {
    this.checkingComponent = "transactions";
    // console.log("content?", content);
    // console.log("j=>", j);
    // console.log("payment=>", payment);
    this.backtoTransactionDetail();
    // this.renderer.addClass(document.body, "modal-open");
    this.modifierValidation = "0";
    this.paymentReceiptCopy = payment;
    let copyObj = JSON.parse(JSON.stringify(payment));
    console.log("When-Clicked-on-Transactionsss", copyObj);
    console.log("Content: ", content);
    this.globalAmount = copyObj.paymentAmount;
    console.log("Global--AMOUNTTT", this.globalAmount);

    copyObj.orderId.seats.forEach((element1) => {
      element1.orderProducts.forEach((element2) => {
        var temp = [];
        element2.productModifiers.forEach((element3, index) => {
          if (
            element3.hasMultipleOptions == true &&
            this.modifierValidation == element3.modifierGroupId
          ) {
            if (index == 0) {
              temp.push({
                modifierName: element3.modifierName,
                childrens: [
                  {
                    modifierOptionName: element3.modifierOptionName,
                  },
                ],
              });
            } else {
              temp[temp.length - 1].childrens.push({
                modifierOptionName: element3.modifierOptionName,
              });
            }
          } else {
            temp.push({
              modifierName: element3.modifierName,
              childrens: [
                {
                  modifierOptionName: element3.modifierOptionName,
                },
              ],
            });
          }
          this.modifierValidation = element3.modifierGroupId;
          element2.AllproductModifiers = temp;
        });
        element2.modifierGroupById = _(element2.productModifiers)
          .groupBy("modifierId")
          .map((modifier, id) => ({
            modifierTotalPrice: _.sumBy(modifier, "modifierPrice"),
            modifierName: modifier[0].modifierName,
            modifierOptions: modifier,
          }))
          .value();
      });
    });
    this.paymentReceipt = copyObj;
    // this.paymentReceiptCopy = copyObj;
    this.deliveryFee = copyObj.orderId.deliveryAmount;
    this.promoCodeValue = copyObj.orderId.promoCodeAmount || 0;
    //this.seeFirstPage = "0";
    this.editOrdenSecondStep = true;
    this.index = j;
    // this.modalService.open(
    //   content,
    //   {
    //     windowClass: 'right animate__animated animate__slideInRight'
    //   }
    // );
    this.openEnd(content);
  }

  openEnd(orderdetail: TemplateRef<any>) {
    this.offcanvasService.open(orderdetail, { position: "end" });
  }
  /**
   * Close modal
   * @param content modal content
   */
  closeModal(content: any) {
    // this.renderer.removeClass(document.body, "modal-open");
    this.modalService.dismissAll(content);
    this.backtoTransactionDetail();
    this.editOrdenSecondStep = false;
  }

  sumarrays(transactions: any) {
    var temptransaction = [];
    temptransaction = transactions;
    var sum = 0;
    for (let i = 0; i < temptransaction.length; i++) {
      //if (temptransaction[i].transactionStatus !== 6)
      sum += parseFloat(temptransaction[i].transactionAmount);
    }
    return sum.toFixed(2);
  }

  convertStringToNumber = (arrayString) => {
    let numberArray = arrayString.map((element) => {
      return parseInt(element);
    });
    return numberArray;
  };

  getPaymentMethodIds = () => {
    let paymentMethodIds = this.transactions$
      .map((element) => {
        const transactionIds = element.transactionIds.map(
          (transaction) => transaction.transactionTypeId
        );
        return transactionIds;
      })
      .flat();

    const uniquePaymentMethodIds = [...new Set(paymentMethodIds)];

    console.log("Ids: ", uniquePaymentMethodIds);
    return uniquePaymentMethodIds;
  };

  exportReport = (file: String) => {
    this.isLoadData = false;
    this.offcanvasService.dismiss("cross click");
    this.OpenDetails = "mainMenu";
    this.store.dispatch(setLoadingSpinner({ status: true }));
    // if (this.startTime != "") {
    //   const hour = Number(this.startTime) || 0;
    //   const minutes = 0; // since we dont select mins in drop down
    //   this.startDateDisplay = this.timezoneService
    //     .get()(this.startDate)
    //     .subtract(0, "days")
    //     .set({ hours: hour })
    //     .set({ minutes: minutes })
    //     .unix();
    // }
    // if (this.endTime != "") {
    //   const hour2 = Number(this.endTime) || 0;
    //   const minutes2 = 0; // since we dont select mins in drop down
    //   this.endDateDisplay = this.timezoneService
    //     .get()(this.endDate)
    //     .subtract(0, "days")
    //     .set({ hours: hour2 })
    //     .set({ minutes: minutes2 })
    //     .unix();
    // }

    const timeDifference = this.endDateDisplay - this.startDateDisplay;
    const oneMonthInSeconds = 30 * 24 * 60 * 60;
    const paymentMethodIds = this.getPaymentMethodIds();
    let paymentMethodIdsValues = [];
    if (this.resultRevenueIds.length > 0 && this.salesCardType != "") {
      // push the resultRevenueIds and salesCardType into paymentMethodIdsValues
      paymentMethodIdsValues = this.resultRevenueIds.concat([
        parseInt(this.salesCardType),
      ]);
    } else if (this.resultRevenueIds.length == 0 && this.salesCardType != "") {
      paymentMethodIdsValues = [parseInt(this.salesCardType)];
    } else if (this.resultRevenueIds.length > 0 && this.salesCardType == "") {
      paymentMethodIdsValues = this.resultRevenueIds;
    } else {
      paymentMethodIdsValues = [];
    }

    const params = {
      reportName: "payments_report",
      format: file,
      merchantId: this.merchantId,
      query: {
        employeeIds:
          this.resultEmployeeIds === "" ? [] : this.resultEmployeeIds,
        // paymentMethodIds: this.salesCardType === "" ? [] : this.salesCardType,
        // paymentMethodIds: this.salesCardType === "" ? [] : [this.salesCardType],
        // paymentMethodIds: paymentMethodIds,
        orderStatuses: this.pageLoad
          ? [3, 4, 5, 6, 8, 9]
          : this.orderSellStatusId === ""
            ? []
            : [parseInt(this.orderSellStatusId)],
        orderTypes: this.orderTypeId === "" ? [] : [parseInt(this.orderTypeId)],
        // replace reseultRevenueIds with paymentMethodIdsValues
        paymentMethodIds: paymentMethodIdsValues,
        // paymentMethodIds: this.resultRevenueIds === ""
        //   ? []
        //   : this.convertStringToNumber(this.resultRevenueIds),
        // salesCardNumber: this.salesCardNumber,
        // salesCardType: this.salesCardType,

        merchantId: this.merchantId,
        storeId: this.storeIdFixed,
        startDate: this.startDateDisplay,
        endDate: this.endDateDisplay,
        lastStartDate: this.lastStartDate,
        lastEndDate: this.lastEndDate,
        paymentStatuses:
          this.paymentStatusId == "" ? [] : [parseInt(this.paymentStatusId)],
        // startTime: startTime,
        // endTime: endTime,
      },
    };

    let startTime = this.timezoneService
    .get()
    .unix(this.startDateDisplay)
    .format("HH:mm");

    let endTime = this.timezoneService
      .get()
      .unix(this.endDateDisplay)
      .format("HH:mm");

    if (
      (startTime !== "00:00" && endTime === "23:59") ||
      (endTime !== "23:59" && startTime === "00:00") ||
      (startTime !== "00:00" && endTime !== "23:59")
    ) {
      params.query["startTime"] = startTime;
      params.query["endTime"] = endTime;
    }

    this.transactionService.exportReport(params).subscribe(
      (response: any) => {
        if (response.error === true) {
          this.toastr.error(response.message);
          this.store.dispatch(setLoadingSpinner({ status: false }));
        } else if (response.success == 1) {
          this.store.dispatch(setLoadingSpinner({ status: false }));
          this.toastr.info(
            "This will take 10-15 minutes to be exported and will be sent over e-mail."
          );
        } else {
          if (response && response.data && response.data.url) {
            let headers = new HttpHeaders();
            headers = headers.set("Accept", "application/pdf");
            this.http
              .get(response.data.url, {
                headers: headers,
                responseType: "blob",
              })
              .subscribe((blob: Blob): void => {
                var blob = new Blob([blob], {
                  type: response.data.contentType,
                });
                var url = window.URL.createObjectURL(blob);
                var anchor = document.createElement("a");
                anchor.download = response.data.name;
                anchor.href = url;
                anchor.click();
              });
            this.store.dispatch(setLoadingSpinner({ status: false }));
            this.toastr.success("File exported");
          } else {
            // Handle the case where response, response.data, or response.data.url is undefined
            this.toastr.error("Unable to export the file. Data is missing.");
          }
        }
      },
      (err) => {
        this.toastr.error(err.message);
        this.store.dispatch(setLoadingSpinner({ status: false }));
      }
    );
  };

  closeBatch() {
    if (this.permissionService.canAccess('SalesTransaction', 3)) {
      this.offcanvasService.dismiss("cross click");
      if (this.storeId == "*") {
        this.toastr.error("Please select a location first.");
      } else {
        this.store.dispatch(setLoadingSpinner({ status: true }));
        let payload = {
          storeId: this.storeId,
        };
        this.transactionService.closeBatch(payload).subscribe(
          (response) => {
            if (response.success == 0) {
              this.toastr.error(response.message);
              this.store.dispatch(setLoadingSpinner({ status: false }));
            } else {
              this.toastr.success("Batch closed succesfully");
              // this.ngOnInit();
              this.getNumberCountPayments();
            }
          },
          (error) => {
            this.toastr.error(error);
            this.store.dispatch(setLoadingSpinner({ status: false }));
          }
        );
      }
    } else {
      this.toastr.error("You are not authorized to perform this operation.");
    }
  }

  receiptModal = false;
  globalOrderId: any = "";
  globalTip = 0;
  globalAmount = 0;
  tipGlobal = 0;
  ModuleDetails = "transaction";
  sendReceipt(event: any) {
    this.globalAmount = 0;
    this.globalOrderId = "";
    //this.phone = "";
    this.globalOrderId = event.orderId.orderId;
    this.globalAmount = event.paymentAmount;
    this.tipGlobal = event.paymentTipAmount;
    this.receiptModal = true;
  }
  refundModalPageOne = false;
  voidModalPageOne = false;
  refundModalPageTwo = false;
  voidModalPageTwo = false;
  pRefundModalPageOne = false;
  cRefundModalPageOne = false;
  pRefundModalPageTwo = false;
  cRefundModalPageTwo = false;
  refundModalLoader = false;
  voidModalLoader = false;
  refundModalSuccess = false;
  voidModalSuccess = false;
  orderEditModalPageOne = false;
  orderEditModalPageTwo = false;
  orderEditModalPageThree = false;
  fullRefund(event: any) {
    this.globalAmount = 0;
    this.globalOrderId = "";
    this.globalOrderId = event.orderId.orderId;
    this.globalAmount = event.paymentAmount;
    this.tipGlobal = event.paymentTipAmount;
    this.refundModalLoader = false;
    this.voidModalLoader = false;
    this.refundModalSuccess = false;
    this.voidModalSuccess = false;
    this.receiptModal = false;
    this.orderEditModalPageOne = false;
    this.orderEditModalPageTwo = false;
    this.orderEditModalPageThree = false;
    this.refundModalPageOne = true;
    this.voidModalPageOne = false;
  }
  voidOrder(event: any) {
    this.globalAmount = 0;
    this.globalOrderId = "";
    this.globalOrderId = event.orderId.orderId;
    this.globalAmount = event.paymentAmount;
    this.tipGlobal = event.paymentTipAmount;
    this.refundModalLoader = false;
    this.voidModalLoader = false;
    this.refundModalSuccess = false;
    this.voidModalSuccess = false;
    this.receiptModal = false;
    this.orderEditModalPageOne = false;
    this.orderEditModalPageTwo = false;
    this.orderEditModalPageThree = false;
    this.refundModalPageOne = false;
    this.voidModalPageOne = true;
  }
  goToRefundPageTwo() {
    this.receiptModal = false;
    this.orderEditModalPageOne = false;
    this.orderEditModalPageTwo = false;
    this.orderEditModalPageThree = false;
    this.refundModalPageOne = false;
    this.voidModalPageOne = false;
    this.refundModalPageTwo = true;
    this.voidModalPageTwo = false;
  }
  goToVoidPageTwo() {
    this.receiptModal = false;
    this.orderEditModalPageOne = false;
    this.orderEditModalPageTwo = false;
    this.orderEditModalPageThree = false;
    this.refundModalPageOne = false;
    this.voidModalPageOne = false;
    this.refundModalPageTwo = false;
    this.voidModalPageTwo = true;
  }
  backtoTransactionDetail() {
    // this.paymentReceipt = this.paymentReceiptCopy;
    this.noteReason = "";
    this.refundReason = "";
    this.receiptModal = false;
    this.refundModalPageOne = false;
    this.voidModalPageOne = false;
    this.refundModalPageTwo = false;
    this.voidModalPageTwo = false;
    this.refundModalLoader = false;
    this.voidModalLoader = false;
    this.refundModalSuccess = false;
    this.voidModalSuccess = false;
    this.pRefundModalPageOne = false;
    this.cRefundModalPageOne = false;
    this.pRefundModalPageTwo = false;
    this.cRefundModalPageTwo = false;
    this.orderEditModalPageOne = false;
    this.orderEditModalPageTwo = false;
    this.orderEditModalPageThree = false;
    this.refundProductList = [];
    this.totalPartialRefund = 0.0;
    this.partialRefundActive = false;
  }
  backtoRefundPageOne() {
    this.noteReason = "";
    this.refundReason = "";
    this.receiptModal = false;
    this.orderEditModalPageOne = false;
    this.orderEditModalPageTwo = false;
    this.orderEditModalPageThree = false;
    this.refundModalPageOne = true;
    this.voidModalPageOne = false;
    this.refundModalPageTwo = false;
    this.voidModalPageTwo = false;
  }

  backtoVoidPageOne() {
    this.noteReason = "";
    this.refundReason = "";
    this.receiptModal = false;
    this.orderEditModalPageOne = false;
    this.orderEditModalPageTwo = false;
    this.orderEditModalPageThree = false;
    this.refundModalPageOne = false;
    this.voidModalPageOne = true;
    this.refundModalPageTwo = false;
    this.voidModalPageTwo = false;
  }

  partialRefundPage(event: any) {
    this.globalAmount = 0;
    this.globalOrderId = "";
    this.globalOrderId = event.orderId.orderId;
    this.globalAmount = event.paymentAmount;
    this.tipGlobal = event.paymentTipAmount;
    this.noteReason = "";
    this.refundReason = "";
    this.receiptModal = false;
    this.orderEditModalPageOne = false;
    this.orderEditModalPageTwo = false;
    this.orderEditModalPageThree = false;
    this.pRefundModalPageOne = true;
    this.cRefundModalPageOne = false;
    this.pRefundModalPageTwo = false;
    this.cRefundModalPageTwo = false;
  }

  customRefundPage(event: any) {
    this.globalAmount = 0;
    this.globalOrderId = "";
    this.globalOrderId = event.orderId.orderId;
    this.globalAmount = event.paymentAmount;
    this.tipGlobal = event.paymentTipAmount;
    this.noteReason = "";
    this.refundReason = "";
    this.receiptModal = false;
    this.orderEditModalPageOne = false;
    this.orderEditModalPageTwo = false;
    this.orderEditModalPageThree = false;
    this.pRefundModalPageOne = false;
    this.cRefundModalPageOne = true;
    this.pRefundModalPageTwo = false;
    this.cRefundModalPageTwo = false;
  }

  backtoPrefundPageOne() {
    this.noteReason = "";
    this.refundReason = "";
    this.receiptModal = false;
    this.orderEditModalPageOne = false;
    this.orderEditModalPageTwo = false;
    this.orderEditModalPageThree = false;
    this.pRefundModalPageOne = true;
    this.cRefundModalPageOne = false;
    this.pRefundModalPageTwo = false;
    this.cRefundModalPageTwo = false;
    // this.refundProductList = [];
    // this.totalPartialRefund = 0.0;
  }
  goToPRefundPageTWo() {
    this.noteReason = "";
    this.refundReason = "";
    this.receiptModal = false;
    this.orderEditModalPageOne = false;
    this.orderEditModalPageTwo = false;
    this.orderEditModalPageThree = false;
    this.pRefundModalPageOne = false;
    this.cRefundModalPageOne = false;
    this.pRefundModalPageTwo = true;
    this.cRefundModalPageTwo = false;
  }

  backtoCrefundPageOne() {
    this.noteReason = "";
    this.refundReason = "";
    this.receiptModal = false;
    this.orderEditModalPageOne = false;
    this.orderEditModalPageTwo = false;
    this.orderEditModalPageThree = false;
    this.pRefundModalPageOne = false;
    this.cRefundModalPageOne = true;
    this.pRefundModalPageTwo = false;
    this.cRefundModalPageTwo = false;
  }
  goToCRefundPageTWo() {
    this.noteReason = "";
    this.refundReason = "";
    this.receiptModal = false;
    this.orderEditModalPageOne = false;
    this.orderEditModalPageTwo = false;
    this.orderEditModalPageThree = false;
    this.pRefundModalPageOne = false;
    this.cRefundModalPageOne = false;
    this.pRefundModalPageTwo = false;
    this.cRefundModalPageTwo = true;
  }
  changeRefundReason(event: any) {
    this.refundReason = event;
  }
  changeRefundReasonNote(event: any) {
    this.noteReason = event;
  }

  changeCRefundReason(event: any) {
    this.refundReason = event;
  }
  changeCRefundReasonNote(event: any) {
    this.noteReason = event;
  }
  fullPaymentRefund(event: any) {
    this.refundModalPageOne = false;
    // this.voidModalPageOne = false;
    this.refundModalPageTwo = false;
    this.receiptModal = false;
    this.orderEditModalPageOne = false;
    this.orderEditModalPageTwo = false;
    this.orderEditModalPageThree = false;
    let payments = JSON.parse(JSON.stringify(this.transactions$));
    if (
      event.orderId.orderSellStatus == 4 ||
      event.orderId.orderSellStatus == 5
    ) {
      this.refundModalLoader = true;
      var params = {
        reason: this.refundReason,
        orderId: event.orderId.orderId,
        notes: this.noteReason,
      };
      // Updated the Refund API Endpoint('/payment/refund') to '/payment/refund/new'
      return this.http
        .post(this.GLOBALURL + "/payment/refund/new", params, this.httpOptions1)
        .subscribe(
          (response: any) => {
            if (response.success === 1) {
              this.toastr.success(response.message);
              payments[this.index] = response.response;

              this.transactions$ = payments;
              this.refundModalLoader = false;
              this.refundModalSuccess = true;
              this.noteReason = "";
              this.refundReason = "";
              // window.location.reload();
              // this.getNumberCountPayments();
            } else {
              this.refundModalLoader = false;
              this.toastr.error(response.message);
            }
          },
          (error) => {
            this.refundModalLoader = false;
            this.refundModalSuccess = false;
            const message = this.ApiService.errorMessage(error);
            this.toastr.error(message);
          }
        );
    } else {
      this.refundModalLoader = false;
      this.refundModalSuccess = false;
      this.toastr.warning(
        "After a custom refund, you are not permitted to perform any additional refunds for the same order"
      );
    }
  }

  voidOrderLoader: Boolean = false;
  voidPayment(event: any) {
    console.log("VOID_API_CALLED", event);
    // this.buttonApprove = false;
    this.voidOrderLoader = true;
    this.voidModalPageOne = false;
    this.voidModalPageTwo = false;
    this.voidModalLoader = true;
    this.receiptModal = false;
    this.orderEditModalPageOne = false;
    this.orderEditModalPageTwo = false;
    this.orderEditModalPageThree = false;
    let payments = JSON.parse(JSON.stringify(this.transactions$));
    // const parameters = {
    // "paymentId": "410326e606e908ae0e696d07",
    // "transactionId": "ac5330410a819371cf41e342",
    // "orderId":"95f616544653566e4199e1c5",
    // "merchantId":"64760c6e5ded0c112b26f5bc",
    // "reason":"test",
    // "notes":"test"
    // };
    const parameters = {
      paymentId: event.paymentId,
      transactionId: event.transactionIds[0].transactionId,
      orderId: event.orderId.orderId,
      merchantId: event.orderId.merchantId,
      reason: this.refundReason,
      notes: this.noteReason,
    };

    return this.http
      .post(this.GLOBALURL + "/payment/void", parameters, this.httpOptions1)
      .subscribe(
        (response: any) => {
          if (response.success == 0) {
            this.toastr.error(response.message);
            this.voidOrderLoader = false;
            this.voidModalLoader = false;
            this.voidModalSuccess = false;
          } else {
            this.toastr.success(response.message);
            payments[this.index] = response.response;
            console.log("VOID_API_RESPONSE", response.response);

            this.transactions$ = payments;
            this.voidOrderLoader = false;
            this.voidModalLoader = false;
            this.voidModalSuccess = true;
            this.noteReason = "";
            this.refundReason = "";
            // window.location.reload();
            // this.getNumberCountPayments();
          }
        },
        (error) => {
          this.voidOrderLoader = false;
          this.voidModalLoader = false;
          this.voidModalSuccess = false;
          const message = this.ApiService.errorMessage(error);
          this.toastr.error(message);
        }
      );
  }

  closeOrderLoader = false;
  closeOrderStatus = false;
  closeOrder(payment: any, content: any) {
    this.closeOrderLoader = true;
    this.closeOrderStatus = false;
    var params = {
      paymentId: payment.paymentId,
    };
    let payments = JSON.parse(JSON.stringify(this.transactions$));
    return this.http
      .post(this.GLOBALURL + "/payment/close", params, this.httpOptions1)
      .subscribe(
        (response: any) => {
          if (response.success === 1) {
            this.closeOrderStatus = true;
            this.toastr.success(response.message);
            payments[this.index] = response.response;
            this.transactions$ = payments;
            this.closeOrderLoader = false;
            this.closeModal(content);
            // this.summaryCompRef.increaseCloseTransaction()
          } else {
            this.closeOrderStatus = false;
            this.toastr.error(response.message);
            this.closeOrderLoader = false;
          }
        },
        (error) => {
          this.closeOrderStatus = false;
          this.closeOrderLoader = false;
          // this.toastr.error(error.error.message);
          const message = this.ApiService.errorMessage(error);
          this.toastr.error(message);
        }
      );
  }
  refundProductList: any = [];
  totalPartialRefund = 0.0;
  customRefund = 0.0;
  customRefund1 = 0.0;
  // addProductsInListToRefund(product: any) {
  //   // this.refundProductList = [];
  //   this.totalPartialRefund = 0;
  //   const isTheProductOnList = this.refundProductList.find(
  //     (currentProduct: any) => {
  //       return currentProduct === product;
  //     }
  //   );
  //   if (isTheProductOnList === undefined) {
  //     this.refundProductList.push(product);
  //   } else {
  //     // this.refundProductList = this.refundProductList.filter(
  //     //   (currentProduct: any) => {
  //     //     return currentProduct !== product;
  //     //   }
  //     // );
  //     // Check and replace the Whole product Object if Already exist in the list i.e 'product.productId' is Already exist in the list
  //     // if(this.refundProductList.find((currentProduct: any) => currentProduct.productId === product.productId)) {
  //     //   this.refundProductList = this.refundProductList.map((currentProduct: any) => {
  //     //     if (currentProduct.productId === product.productId) {
  //     //       currentProduct.productQuantity = product.productQuantity;
  //     //     }
  //     //     return currentProduct;
  //     //   } );
  //     // }

  //     this.refundProductList = this.refundProductList.map((currentProduct: any) => {
  //       if (currentProduct.productId === product.productId) {
  //         currentProduct.productQuantity = product.productQuantity;
  //       }
  //       return currentProduct;
  //     } );
  //   }
  //   this.totalPartialRefund = this.refundProductList.reduce((acc, obj) => {
  //     return acc + obj.productUnitPrice * obj.productQuantity;
  //   }, 0);

  //   console.log("this.totalPartialRefund", this.totalPartialRefund);
  //   // console.log({
  //   //   totalPartialRefund: this.totalPartialRefund,
  //   //   refundProductList: this.refundProductList,
  //   //   product,
  //   // });
  // }

  getSource(onlineOrderType: number) {
    switch (onlineOrderType) {
      case 5:
        return '| Uber Eats';
      case 15:
        return '| Doordash';
      default:
        return '';
    }
  }

  addProductsInListToRefund(product: any) {
    console.log("product", product);
    this.totalPartialRefund = 0;

    const productIndex = this.refundProductList.findIndex(
      (currentProduct) =>
        currentProduct.orderedProductId === product.orderedProductId
    );

    if (productIndex !== -1) {
      // const updatedProduct = { ...product };
      // this.refundProductList[productIndex] = updatedProduct;
      if (product.shouldRemove === false) {
        console.log("PRODUCT_REMOVED");
        this.refundProductList.splice(productIndex, 1);
      } else {
        const updatedProduct = { ...product };
        this.refundProductList[productIndex] = updatedProduct;
        console.log("PRODUCT_ADDEDDD");
      }
    } else {
      this.refundProductList.push(product);
      console.log("PRODUCT_ADDEDDD");
    }
    // Check if 'AllproductModifiers' is Present in the product Object
    if (product.AllproductModifiers) {
      this.totalPartialRefund = this.refundProductList.reduce((acc, obj) => {
        // Calculate the total price of the modifiers
        let modTotalPrice = obj.modifierGroupById.reduce((acc, obj) => {
          return acc + obj.modifierTotalPrice;
        }, 0);
        modTotalPrice = modTotalPrice * obj.productQuantity;
        return acc + obj.productUnitPrice * obj.productQuantity + modTotalPrice;
      }, 0);
    } else {
      this.totalPartialRefund = this.refundProductList.reduce((acc, obj) => {
        return acc + obj.productUnitPrice * obj.productQuantity;
      }, 0);
    }
  }
  // ##ALTERNATIVE FUNCTION FOR 'addProductsInListToRefund'
  // addProductsInListToRefund(product: any) {
  //   this.totalPartialRefund = 0;

  //   const existingProductIndex = this.refundProductList.findIndex(
  //     (currentProduct: any) => currentProduct.productId === product.productId
  //   );

  //   if (existingProductIndex === -1) {
  //     // Product is not in the list, add it
  //     this.refundProductList.push(product);
  //   } else {
  //     // Product is already in the list, update the quantity
  //     this.refundProductList[existingProductIndex].productQuantity = product.productQuantity;
  //   }

  //   this.totalPartialRefund = this.refundProductList.reduce((acc, obj) => {
  //     return acc + obj.productUnitPrice * obj.productQuantity;
  //   }, 0);
  // }

  isChecked = (product: any) => {
    return this.refundProductList.find((currentProduct) => {
      return currentProduct === product;
    }) === undefined
      ? false
      : true;
  };
  changeRefundAmont(event: any) {
    this.totalPartialRefund = event;
  }
  changeCRefundAmont(event: any) {
    this.customRefund = event;
  }
  partialRefundActive = false;
  partialPaymentRefund(event: any) {
    if (!this.refundReason) {
      this.toastr.error("One reason must be selected");
      return;
    }
    this.pRefundModalPageOne = false;
    this.pRefundModalPageTwo = false;
    this.receiptModal = false;
    if (this.refundReason !== "" && this.refundProductList.length !== 0) {
      this.partialRefundActive = true;
      this.refundModalLoader = true;
      const params = {
        reason: this.refundReason,
        orderId: this.globalOrderId,
        // orderProductIds: this.refundProductList.map((product) => { return product.orderedProductId }),
        orderProducts: this.refundProductList.map((product: any) => {
          return {
            orderProductId: product.orderedProductId,
            quantity: product.productQuantity,
          };
        }),
        notes: this.noteReason,
      };
      let payments = JSON.parse(JSON.stringify(this.transactions$));
      // Updated the Refund API Endpoint('/payment/refund') to '/payment/refund/new'
      return this.http
        .post(this.GLOBALURL + "/payment/refund/new", params, this.httpOptions1)
        .subscribe(
          (response: any) => {
            if (response.success === 1) {
              this.toastr.success(response.message);
              payments[this.index] = response.response;
              this.transactions$ = payments;
              this.refundModalLoader = false;
              this.refundModalSuccess = true;
              // this.getNumberCountPayments();
            } else {
              this.toastr.error(response.message);
              this.refundModalLoader = false;
            }
          },
          (error) => {
            this.refundModalLoader = false;
            this.toastr.error(error.error.message);
          }
        );
    } else {
      this.refundModalLoader = false;
      this.toastr.error("Please complete all the fields");
    }
  }

  //custom refund
  customRefundActive = false;
  customRefundedS = false;
  customPaymentRefund(event: any) {
    console.log(this.customRefund, "======custom refund====");
    if (!this.refundReason) {
      this.toastr.error("One reason must be selected");
      return;
    }
    this.cRefundModalPageOne = false;
    this.cRefundModalPageTwo = false;
    this.receiptModal = false;
    this.refundModalLoader = true;
    if (this.refundReason !== "") {
      this.customRefundActive = true;
      const params = {
        reason: this.refundReason,
        orderId: this.globalOrderId,
        amount: Number(this.customRefund),
        notes: this.noteReason,
      };
      this.customRefund1 = this.customRefund;
      let payments = JSON.parse(JSON.stringify(this.transactions$));
      // Updated the Refund API Endpoint('/payment/refund') to '/payment/refund/new'
      return this.http
        .post(this.GLOBALURL + "/payment/refund/new", params, this.httpOptions1)
        .subscribe(
          (response: any) => {
            if (response.success === 1) {
              this.toastr.success(response.message);
              payments[this.index] = response.response;
              this.transactions$ = payments;
              this.refundModalLoader = false;
              this.refundModalSuccess = true;
              this.customRefundedS = true;
              this.customRefund = 0.0;
              // this.getNumberCountPayments();
            } else {
              this.customRefund = 0.0;
              this.toastr.error(response.message);
              this.refundModalLoader = false;
            }
          },
          (error) => {
            this.customRefund = 0.0;
            this.refundModalLoader = false;
            this.toastr.error(error.error.message);
          }
        );
    } else {
      this.refundModalLoader = false;
      this.toastr.error("Please complete all the fields");
    }
  }

  buttonApprove: boolean = false;
  editOrderLoader: Boolean = false;
  // isVoidTransaction: boolean = false;
  editOrder(event: any) {
    this.buttonApprove = false;
    this.editOrderLoader = true;
    var parameters: any;
    if (
      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        this.account
      )
    ) {
      parameters = {
        type: 1,
        username: this.account,
      };
    } else {
      parameters = {
        type: 2,
        mobile: this.account,
      };
    }
    return this.http
      .post(this.GLOBALURL + "/user/sendotp", parameters, this.httpOptions1)
      .subscribe(
        (response: any) => {
          if (response.success == 0) {
            this.toastr.error(response.message);
            this.editOrderLoader = false;
            this.editOrdenSecondStep = true;
          } else {
            this.editOrderLoader = false;
            this.orderEditModalPageOne = true;
            this.orderEditModalPageTwo = false;
            this.runTime();
          }
        },
        (error) => {
          this.editOrderLoader = false;
          this.toastr.error(error.error.message);
        }
      );
  }

  idInterval: any;
  timeToVerify: any = 0;
  timerDisplay: string = "5:00";
  runTime() {
    let ini = 0;
    this.timeToVerify = 300;
    this.idInterval = setInterval(() => {
      if (this.timeToVerify > 0) {
        this.timeToVerify = this.timeToVerify - 1;
        this.timerDisplay = this.formatTimer(this.timeToVerify);
      } else if (
        this.timeToVerify >= 0 &&
        ini < 2 &&
        this.orderEditModalPageTwo == false &&
        this.orderEditModalPageOne == true
      ) {
        console.log("OTP code has expired");
        this.toastr.error("OTP code has expired");
        ini++;
        clearInterval(this.idInterval);
      } else if (
        this.timeToVerify >= 0 &&
        ini < 2 &&
        this.orderEditModalPageTwo == true &&
        this.orderEditModalPageOne == false
      ) {
        // this.toastr.error("OTP code has expired");
        console.log("OTP VERIFIED AND MOVED TO NEXT STAGE");
        ini++;
        clearInterval(this.idInterval);
      }
    }, 1000);
  }

  formatTimer(seconds: number) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const paddedSeconds = remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds;
    return `${minutes}:${paddedSeconds}`;
  }

  isVerificationOk(code) {
    var parameters: any;
    if (
      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        this.account
      )
    ) {
      parameters = {
        otp: code,
        username: this.account,
      };
    } else {
      parameters = {
        otp: code,
        mobile: this.account,
      };
    }
    return this.http
      .post(this.GLOBALURL + "/user/verifyOTP", parameters, this.httpOptions1)
      .subscribe(
        (response: any) => {
          if (response.success == 1) {
            this.buttonApprove = true;
            // this.toastr.success(response.message);
            clearInterval(this.idInterval);
          } else {
            // this.buttonApprove = false;
            // this.toastr.error(response.message);
            console.log(response.message);
          }
        },
        (error) => {
          this.toastr.error(error.error.message);
        }
      );
  }
  nextPage() {
    this.orderEditModalPageOne = false;
    this.orderEditModalPageTwo = true;
  }
  canResendOTP = true;
  secondsTominutes(secs) {
    if (secs == 180) {
      this.canResendOTP = false;
      return `3:00`;
    }

    if (secs < 180 && secs > 120) {
      this.canResendOTP = false;
      if (secs <= 129 && secs > 120) {
        return `2:0${secs - 120}`;
      } else {
        return `2:${secs - 120}`;
      }
    }

    if (secs == 120) {
      return `2:00`;
    }
    if (secs < 120 && secs > 60) {
      this.canResendOTP = false;
      if (secs <= 69 && secs > 60) {
        return `1:0${secs - 60}`;
      } else {
        return `1:${secs - 60}`;
      }
    }
    if (secs == 60) {
      return `1:00`;
    }

    if (secs < 60 && secs > 0) {
      this.canResendOTP = false;
      if (secs <= 9 && secs > 0) {
        return `0:0${secs}`;
      } else {
        return `0:${secs}`;
      }
    }
    if (secs == 0) {
      if (!this.canResendOTP) {
        this.canResendOTP = true;
      }
      return `0:00`;
    }
  }
  resendOtpEditOrder() {
    if (this.canResendOTP) {
      this.canResendOTP = false;
      var parameters: any;
      if (
        /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
          this.account
        )
      ) {
        parameters = {
          type: 1,
          username: this.account,
        };
      } else {
        parameters = {
          type: 2,
          mobile: this.account,
        };
      }
      this.timeToVerify = 180;
      return this.http
        .post(this.GLOBALURL + "/user/sendotp", parameters, this.httpOptions1)
        .subscribe(
          (response: any) => {
            if (response.success == 0) {
            } else {
              this.toastr.success("otp has been re-sended");
              this.runTime();
              this.cleanOtp();
            }
          },
          (error) => {
            this.toastr.error(error.error.message);
          }
        );
    } else {
      this.toastr.error("Wait until timer is out");
      this.canResendOTP = true;
    }
  }
  cleanOtp() {
    // console.log("this.childRef_CLEAN_OTP", this.childRef)
    // this.childRef.clearOtp();
    if (this.childRef) {
      console.log("this.childRef_FROM_IF_CLEAN_OTP", this.childRef);
      this.childRef.clearOtp();
    } else {
      return;
    }
  }
  editPayment: any = {};
  editTransaction: any = {};
  tipAmount: any = 0.0;
  selectTransactionEditOrder(ts) {
    console.log("ts", ts);
    this.editPayment = {};
    this.editTransaction = {};
    this.editTransaction = ts.transaction;
    this.userSelected = ts.paymentReceipt.orderId.serverId.employeeId;
    console.log("this.userSelected", this.userSelected);
    this.editPayment = ts.paymentReceipt;
    this.tipAmount =
      this.editPayment.transactionIds[
        this.editPayment.transactionIds.length - 1
      ].transactionTipAmount;
    this.orderEditModalPageThree = true;
  }
  backtoEditorderPageTwo() {
    this.orderEditModalPageThree = false;
  }
  changeValueSelect(event: any) {
    this.userSelected = event;
    console.log("EVENT_EMIT", this.userSelected);
  }
  changeEditTipAmount(event) {
    this.tipAmount = event;
  }
  chageLoader: Boolean = false;
  changeTipFunction(content) {
    console.log("this.tipAmount", typeof this.tipAmount);
    if (this.tipAmount === 0) {
      this.tipAmount = "0.00";
    } else {
      this.tipAmount = this.tipAmount;
    }
    var parameters = {
      transactionId: this.editTransaction.transactionId,
      tipAmount: this.tipAmount,
      employeeId: this.userSelected,
    };
    let payments = JSON.parse(JSON.stringify(this.transactions$));
    this.chageLoader = true;
    return this.http
      .put(this.GLOBALURL + "/order/tips", parameters, this.httpOptions1)
      .subscribe(
        (response: any) => {
          if (response.success == 1) {
            payments[this.index] = response.response;
            this.transactions$ = payments;
            this.toastr.success(response.message);
            this.chageLoader = false;
            this.clearEditOrder();
            this.paymentReceipt = { ...response.response };
            let index = this.transactions$?.findIndex(
              (obj) => obj.paymentId === response.response.paymentId
            );

            if (index !== -1) {
              const updatedObject = { ...this.paymentReceipt };
              const newArr = [...this.transactions$];
              this.transactions$ = [];
              newArr[index] = updatedObject;
              this.transactions$ = [...newArr];
            }

            this.modalService.dismissAll(content);
            this.backtoTransactionDetail();
          } else {
            this.chageLoader = false;
            this.toastr.error(response.message);
          }
        },
        (error) => {
          this.chageLoader = false;
          // this.toastr.error(error.error.message);
          const message = this.ApiService.errorMessage(error)
          this.toastr.error(message);
        }
      );
  }
  clearEditOrder() {
    this.editPayment = {};
    this.userSelected = "";
    this.tipAmount = "";
    this.editTransaction = {};
  }

  _convertDateKeys = {};
  convertDate(timeStamp: number) {
    if (timeStamp) {
      if (!this._convertDateKeys.hasOwnProperty(timeStamp)) {
        this._convertDateKeys[timeStamp] = this.timezoneService
          .get()(timeStamp * 1000)
          .format("MMM DD, YYYY");
      }
      return this._convertDateKeys[timeStamp];
    } else {
      return "";
    }
  }

  _convertTimeKeys = {};
  convertTime(timeStamp: number) {
    if (timeStamp) {
      if (!this._convertTimeKeys.hasOwnProperty(timeStamp)) {
        this._convertTimeKeys[timeStamp] = this.timezoneService
          .get()
          .unix(timeStamp)
          .format("h:mm A");
      }
      return this._convertTimeKeys[timeStamp];
    } else {
      return "";
    }
  }

  // convertDate(timeStamp: number) {
  //   if (timeStamp) {
  //     return this.timezoneService
  //       .get()(timeStamp * 1000)
  //       .format("MMM DD, YYYY");
  //   } else {
  //     return "";
  //   }
  // }

  // convertTime(timeStamp: number) {
  //   if (timeStamp) {
  //     return this.timezoneService.get().unix(timeStamp).format("h:mm A");
  //   } else {
  //     return "";
  //   }
  // }

  sortData(data) {
    data.sort((a, b) => {
      if (a.orderId.orderNumber < b.orderId.orderNumber) {
        return -1;
      }
      if (a.orderId.orderNumber > b.orderId.orderNumber) {
        return 1;
      }
      return 0;
    });
    return data.sort((a, b) => {
      return <any>new Date(b.createdAt) - <any>new Date(a.createdAt);
    });
  }

  ShowInput: boolean = false;
  paymentStausErr: boolean = false;
  AddedInputCss() {
    this.ShowInput = !this.ShowInput;
  }

  OpenDetails = "mainMenu";
  OpenFilterCanva(content1: TemplateRef<any>) {
    this.offcanvasService.open(content1, { position: "end" });
  }
  isDropdownOpen = false;
  isDropdownOpen1 = false;
  IsEmployeeeError: boolean = false;
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
    this.DropDownStyleSet();
  }
  toggleDropdown1() {
    this.isDropdownOpen1 = !this.isDropdownOpen1;
    this.DropDownStyleSet();

  }

  isDropdownOpen2 = false;
  IsActiveselectCard: boolean = false;

  toggleDropdown2() {
    this.isDropdownOpen2 = !this.isDropdownOpen2;
    this.DropDownStyleSet();
  }
  EndDateErr: boolean = false;
  startDateErr: boolean = false;
  DropDownStyleSet() {
    setTimeout(() => {
      const elements = this.documents.querySelectorAll(".dropdown");
      elements.forEach((element: any) => {
        this.renderer.removeStyle(element, "z-index");
      });
    }, 1000);
  }
  // IsEmployeeeError1: boolean = false;
  paymentMethodeErr: boolean = false;
  EmployeeArrowChange(Data: any) {
    if (Data === 'Employee') {
      this.IsEmployeeeError = !this.IsEmployeeeError
      const elements = this.documents.querySelectorAll(".SetZindex-main");
      elements.forEach((element: any) => {

        this.renderer.setStyle(element, 'z-index', '0');
        this.renderer.setStyle(element, 'width', '100%');

      });
    } else if (Data === 'payment') {
      this.paymentMethodeErr = !this.paymentMethodeErr;

    }
    this.DropDownStyleSet();
  }
  setmainZindex(){

    this.isDropdownOpen1 = !this.isDropdownOpen1
    const elements = this.documents.querySelectorAll(".SetZindex-main");
      elements.forEach((element: any) => {

        // this.renderer.removeStyle(element, 'z-index');
        this.renderer.setStyle(element, 'z-index', '1');
      });
  }

  setDateTexts() {
    setTimeout(() => {
      let ranges = document.querySelectorAll(".ranges li");
      let $ranges = this.createTranslateArr(ranges);

      let months = document.querySelectorAll(".table-condensed .month");
      let $months = this.createTranslateArr(months);

      let buttons = document.querySelectorAll(".drp-buttons .btn");
      let $buttons = this.createTranslateArr(buttons);

      // let days = document.querySelectorAll(".table-condensed thead tr");
      // let first = days[1].querySelectorAll("th");
      // let second = days[3].querySelectorAll("th");
      // let $first = this.createTranslateArr(first);
      // let $second = this.createTranslateArr(second);

      // this.translateArrayOfTexts($first, first);
      this.translateArrayOfTexts($buttons, buttons);
      this.translateArrayOfTexts($ranges, ranges);
      this.translateArrayOfTexts($months, months)

    }, 1);

  }

  createTranslateArr(arr: any) {
    let newArr = [];
    arr.forEach((item) => {
      if (item && typeof item.textContent === 'string') {
        newArr.push(this.translatePipe.transform(item.textContent));
      }
    });
    return newArr;
  }

  translateArrayOfTexts($arrToTranslate: string[], arrOfElements: any) {
    if ($arrToTranslate.length === 0) return;

    forkJoin($arrToTranslate)
      .subscribe(texts => {
        texts.forEach((text, i) => {
          arrOfElements[i].textContent = text;
        });
      },
      (error) => {
        console.error("Error in translating:", error);
      })
  }
}
